export const esMessages = {
  rma: {
    ProductReturnsTitle: 'Devoluciones de Productos',
    AllProductReturns: 'Todas las devoluciones de productos',
    KeepTrackDescription: 'Realiza un seguimiento de todas tus devoluciones de productos',
    NewProductReturn: 'Nueva Devolución de Producto',
    SearchByNameOrReference: 'Buscar por nombre o número de referencia...',
    Filters: 'Filtros',
    ReturnsWithNoTracking: 'Devoluciones sin número de seguimiento',
    From: 'Desde',
    ComplaintsTitle: 'Reclamaciones',
    ReviewAndManage: 'Revisar y gestionar reclamaciones de clientes',
    RecordComplaint: 'Registrar reclamación',
    Status: 'Estado',
    SelectStatus: 'Seleccionar estado',
    MaxResults: 'Máx. resultados',
    SelectColumn: 'Columna',
    SelectOperator: 'Operador',
    SearchFor: 'Buscar por',
    SearchPlaceholder: 'Introducir texto de búsqueda...',
    Search: 'Buscar',
    Filter: 'Filtrar',
    FilterTitle: 'Filtrar reclamaciones',
    ApplyFilters: 'Aplicar filtros',
    ClearFilters: 'Borrar filtros',
    CloseFilters: 'Cerrar',
    NoComplaintsFound: 'No se encontraron reclamaciones para los criterios seleccionados.',
    LastName: 'Apellido',
    FirstName: 'Nombre',
    Name: 'Nombre',
    RMANumber: 'Número RMA',
    RMADetails: 'Detalles RMA',
    DateOfSubmission: 'Fecha de envío',
    CreatedDate: 'Fecha de creación',
    FeeTotal: 'Total de tasas',
    Total: 'Total',
    TrackingNumber: 'Número de seguimiento',
    NoTrackingProvided: 'Sin número de seguimiento',
    Showing: 'Mostrando',
    To: 'a',
    Of: 'de',
    Entries: 'entradas',
    Previous: 'Anterior',
    Next: 'Siguiente',
    Close: 'Cerrar',
    ReturnStatus: 'Estado de devolución',
    CustomerInformation: 'Información del cliente',
    ComplaintDetails: 'Detalles de la reclamación',
    ProductInformation: 'Información del producto',
    RefundInformation: 'Información de reembolso',
    RefundAmount: 'Importe de reembolso',
    ShippingAmount: 'Importe de envío',
    ShippingMethod: 'Método de envío',
    AOEOrderId: 'ID de pedido AOE',
    ClosedDate: 'Fecha de cierre',
    IsSubmitted: 'Está enviado',
    ExportDate: 'Fecha de exportación',
    Notes: 'Notas',
    Yes: 'Sí',
    NotAvailable: 'No disponible',
    All: 'Todos',
    Open: 'Abierto',
    WillBeShipped: 'Será enviado',
    Closed: 'Cerrado',
    Cancelled: 'Cancelado',
    OnHold: 'En espera',
    ReturnExpected: 'Devolución esperada',
    CreditDebitProcessingError: 'Error en procesamiento de pago',
    ClosedWithoutReturns: 'Cerrado sin devoluciones',
    New: 'Nuevo',
    ManualReimbursementRequired: 'Reembolso manual requerido',
    PhotoIsMissing: 'Falta foto',
    ReceiptInProcess: 'Recibo en proceso',
    ReleaseAwaited: 'Esperando liberación',
    StartsWith: 'Comienza con',
    EndsWith: 'Termina con',
    Contains: 'Contiene',
    Equals: 'Es igual a',
    Between: 'Entre',
    GreaterThan: 'Mayor que',
    LessThan: 'Menor que',
    ItemsBeingReturned: 'Artículos que se devuelven',
    ReplacementItems: 'Artículos de reemplazo',
    Exit: 'Salir',
    SubmitSuccess: '¡Éxito!',
    RMASubmittedSuccessfully: '¡RMA {rmaNumber} enviada correctamente!'
    ,ReturnAddress: 'Dirección de devolución'
    ,NoAddressSelected: 'No se seleccionó ninguna dirección'
    ,SelectAddress: 'Seleccionar dirección'
    ,SelectReturnAddress: 'Seleccionar dirección de devolución'
    ,AddNewAddress: 'Agregar nueva dirección'
    ,SubmitRMA: 'Enviar RMA'
    ,GoBack: 'Regresar'
    ,AddressSaved: 'Dirección guardada'
    ,AddressSaveError: 'Error al guardar la dirección'
    ,RequiredAddressFields: 'Por favor completa todos los campos de dirección requeridos'
    ,SelectReasonPlaceholder: 'Selecciona un motivo...'
    ,returnReasons: {
      DUR: 'Rotura durante el uso - DUR',
      DSR: 'Rotura en la entrega - DSR',
      EXR: 'Devolución por cambio - EXR',
    }
    ,errors: {
      enterOrderNumber: 'Por favor ingresa un número de pedido',
      enterValidOrderNumber: 'Por favor ingresa un número de pedido válido',
      failedToLoadOrderDetails: 'No se pudieron cargar los detalles del pedido. Por favor inténtalo de nuevo.',
      orderNotFound: 'Pedido no encontrado. Verifica el número de pedido e inténtalo de nuevo.',
      failedToSearchOrder: 'No se pudo buscar el pedido. Por favor inténtalo de nuevo.',
      orderDetailsNotFound: 'No se encontraron los detalles del pedido',
      rmaNotCreated: 'El RMA no se creó. Regresa e inténtalo de nuevo.',
      failedToSubmitRMA: 'No se pudo enviar el RMA. Por favor inténtalo de nuevo.',
      failedToUpdateRefund: 'No se pudo actualizar la selección de reembolso. Por favor inténtalo de nuevo.',
      failedToLoadPaymentMethods: 'No se pudieron cargar los métodos de pago disponibles. Por favor inténtalo de nuevo.',
      selectAtLeastOneItemToReturn: 'Por favor selecciona al menos un artículo o componente para devolver',
      selectReasonForAllSelectedItems: 'Por favor selecciona un motivo para todos los artículos seleccionados',
      selectReasonForAllSelectedComponents: 'Por favor selecciona un motivo para todos los componentes seleccionados',
      failedToCreateRMA: 'No se pudo crear el RMA. Por favor inténtalo de nuevo.',
    },
    // Order details grid
    Details: 'Detalles',
    Warehouse: 'Almacén',
    LastUpdated: 'Última actualización',
    OrderTotal: 'Total del pedido',
    OrderType: 'Tipo de pedido',
    Orders: 'Pedido',
    OrderNumber: 'Número de pedido',
    OrderDate: 'Fecha del pedido',
    ComplaintSubmitted: 'Reclamación enviada',
    Guests: 'Invitado',
    Customer: 'Cliente',
    CustomerStatus: 'Estado del cliente',
    DeliveryAddress: 'Dirección de entrega',
    EmailAddress: 'Dirección de correo electrónico',
    PhoneNumber: 'Número de teléfono',
    Consultant: 'Consultor',
    Advisor: 'Asesor',
    GoodStanding: 'Al corriente',
    FinancialState: 'Estado financiero',
    // Reason codes
    ReasonCodesTitle: 'Códigos de motivo de devolución',
    ReasonCodeDUR: 'DUR - Rotura en uso',
    ReasonCodeDURDescription: 'El producto está defectuoso durante el uso.',
    ReasonCodeDSR: 'DSR - Rotura en la entrega',
    ReasonCodeDSRDescription: 'El producto llegó dañado.',
    ReasonCodePQ: 'PQR - Calidad del producto',
    ReasonCodePQDescription: 'El producto fue entregado con un defecto o falla.',
    ReasonCodeEX: 'EXR - Intercambio',
    ReasonCodeEXDescription: 'Intercambio por un artículo diferente.',
    ReasonCodesNote: 'Nota: Los intercambios de artículos con más de 30 días no son aceptados. Una vez que hayas enviado tu reclamación con éxito, el equipo de Servicio al Cliente creará una etiqueta de devolución en un plazo de 48-72 horas. Recibirás un correo electrónico separado con tu etiqueta de devolución.',
    // Exchange item selection
    SelectExchangeItem: 'Seleccionar artículo de intercambio',
    SearchForProduct: 'Buscar producto (mín. 3 caracteres)...',
    ExchangeItemSelected: 'Artículo de intercambio seleccionado',
    RemoveExchangeItem: 'Eliminar y seleccionar otro artículo',
    ExchangeItemRequired: 'Artículo de intercambio requerido',
    ExchangeItemRequiredMessage: 'Por favor selecciona un artículo de intercambio para todos los artículos marcados para intercambio',
    UploadPhotos: 'Subir fotos',
    PhotoRequired: 'Requerido',
    PhotoRequiredMessage: 'Por favor sube fotos para todos los artículos que las requieran. Busca los artículos marcados con un asterisco rojo (*).',
    SKUComponents: 'Componentes SKU',
    InitiateReturn: 'Iniciar una devolución',
    EnterOrderNumber: 'Ingresa tu número de pedido a continuación para comenzar el proceso de devolución.',
    OrderNumberPlaceholder: 'Ingresa el número de pedido...',
    Searching: 'Buscando...',
    ExistingRMAFound: 'RMA existente encontrada',
    ExistingRMAMessage: 'Ya se ha enviado una RMA existente para este pedido.',
    ExistingRMAInfo: 'Por favor contacta al servicio al cliente si necesitas ayuda con esta devolución.',
    SelectItemsToReturn: 'Seleccionar artículos a devolver',
    SelectItemsInstruction: 'Selecciona los artículos que deseas devolver y proporciona un motivo para cada uno.',
    SKU: 'SKU',
    ProductCode: 'Código de producto',
    Quantity: 'Cantidad',
    LineTotal: 'Total de línea',
    ReturnReason: 'Motivo de devolución',
    ItemsSelected: 'artículo(s) seleccionado(s)',
    ProceedWithReturn: 'Proceder con la devolución',
    ItemsToReceive: 'Artículos a recibir',
    Totals: 'Totales',
    CreditAmount: 'Importe de crédito',
    Fees: 'Cargos',
    ReturnCreditBalance: 'Saldo de crédito de la devolución',
    NewPurchases: 'Nuevas compras',
    BuyingDiscount: 'Descuento de compra',
    RefundMethod: 'Método de reembolso',
    ReturnCreditRequired: 'Se te debe un crédito por esta devolución. Selecciona cómo deseas que se te reembolse.',
    RefundOriginalPaymentMethod: 'Reembolsar al método de pago original',
    RefundColumnName: 'Pago',
    RefundColumnCharge: 'Cargo original',
    RefundColumnChargeNotRefunded: 'Disponible para reembolso',
    RefundColumnRefundAmount: 'Monto del reembolso',
    RefundRemainingToAllocate: 'Aún debe asignarse {amount} a un método de reembolso antes de poder enviar esta devolución.',
    PaymentRequired: 'Pago requerido',
    PaymentRequiredDescription: 'Se requiere un pago adicional para completar esta devolución. Por favor, proporciona un método de pago a continuación.',
    BrainTreeCreditCardHeader: 'Tarjeta de crédito',
    BrainTreePaymentAmount: 'Monto del pago',
    BrainTreeAddPayment: 'Agregar pago',
    BankPaymentHeader: 'Pagar con cuenta bancaria',
    BankPaymentInstruction: 'Realice un pago con su cuenta bancaria para cubrir el saldo pendiente de esta devolución.',
    BankPaymentYourBankDetails: 'Sus datos bancarios',
    BankPaymentAccountHolder: 'Titular de la cuenta',
    BankPaymentAccountNumber: 'Número de cuenta',
    BankPaymentRoutingNumber: 'Número de ruta bancaria',
    BankPaymentAmount: 'Monto del pago',
    BankPaymentPayWithBank: 'Pagar con cuenta bancaria',
    BankPaymentProcessing: 'Procesando...',
    BankPaymentNoBankDetailsFound: 'No se encontraron datos bancarios. Agregue sus datos bancarios para usar este método de pago.',
  },
  validators: {
    requiredField: '{fieldName} es obligatorio',
    emailField: '{fieldName} es una dirección de correo electrónico no válida',
    fieldMinLength: '{fieldName} debe tener al menos {minimumLength} caracteres.',
    nameMinLength: '{fieldName} debe tener al menos {minimumLength} caracteres.',
    nameMaxLength: '{fieldName} no puede tener más de {maximumLength} caracteres.',
    nameField: '{fieldName} solo puede contener letras, espacios, guiones y apóstrofes',
    phoneNumericOnly: '{fieldName} solo debe contener números (sin espacios ni símbolos)',
    phoneLengthInvalid: '{fieldName} debe tener {min}-{max} dígitos',
    streetField: '{fieldName} solo puede contener letras, espacios, guiones y apóstrofes (sin números ni símbolos)',
    houseNumberField: '{fieldName} debe comenzar con un número y puede contener un sufijo de letra opcional (ej. 12A)',
    cityField: '{fieldName} solo puede contener letras, espacios, guiones y apóstrofes',
    houseNumberFormat: '{fieldName} debe comenzar con un dígito (ej. 12, 12A, 12/3 o 12-14)',
    nameAddressField: '{fieldName} solo puede contener letras, espacios, guiones y apóstrofes',
    nameAddressMinLength: '{fieldName} debe tener al menos {minimumLength} caracteres',
    nameAddressMaxLength: '{fieldName} no puede tener más de {maximumLength} caracteres',
    fieldLength: '{fieldName} debe tener como máximo {maximumLength} caracteres.',
    stepRequirementsHeader: 'Para continuar, complete lo siguiente:',
    contractAgreementRequired: 'Debe aceptar las prácticas comerciales y el código de ética para continuar',
    vatNumberFormat: 'El número de IVA francés debe comenzar con FR seguido de 11 caracteres (ej: FR12345678901)',
    vatNumberFormatATDE: 'El número de IVA debe estar en formato alemán (DE + 9 dígitos) o formato austriaco (ATU + 8 dígitos)',
    ibanFormat: 'El formato del IBAN no es válido. Verifique el código de país y la longitud.',
    ibanFormatFR: 'El IBAN francés debe tener 27 caracteres (FR + 25 dígitos)',
    ibanFormatDE: 'El IBAN alemán debe tener 22 caracteres (DE + 20 dígitos)',
    ibanFormatAT: 'El IBAN austriaco debe tener 20 caracteres (AT + 18 dígitos)',
    bicFormat: 'El BIC debe tener 8 u 11 caracteres con un código de país válido',
    consultantEmailNotAllowed: 'Esta dirección de correo ya está asociada a una cuenta de consultor y no se puede usar para la compra del kit.',
  },
  eventTasks: {
    title: 'Tareas del evento',
    subtitle: 'Prospectos aceptados',
    loading: 'Cargando prospectos...',
    noLeads: 'No se encontraron prospectos aceptados.',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    leadType: 'Tipo de prospecto',
    source: 'Origen',
    note: 'Nota',
    loadingNote: 'Cargando nota...',
    notePlaceholder: 'Agrega una nota sobre este prospecto...',
    saveNote: 'Guardar nota',
    created: 'Creado',
    assigned: 'Asignado',
    accepted: 'Aceptado',
    partyDate: 'Fecha del evento',
    theme: 'Tema',
    bestTime: 'Mejor hora para contactar',
    tasks: 'Tareas',
    due: 'Vence',
    registerNewMember: 'Registrar un nuevo miembro',
    joinMyTeam: 'Únete a mi equipo',
    saveTasks: 'Guardar tareas',
    joinMyTeamUrlCopied: '¡URL de “Únete a mi equipo” copiada al portapapeles!',
    failedToCopyUrl: 'No se pudo copiar la URL. Por favor inténtalo de nuevo.',
    failedToLoadLeads: 'No se pudieron cargar los prospectos. Por favor inténtalo de nuevo.',
    failedToSaveTasks: 'No se pudieron guardar las tareas. Por favor inténtalo de nuevo.',
    failedToSaveNote: 'No se pudo guardar la nota. Por favor inténtalo de nuevo.',
    tasksSavedSuccessfullyFor: 'Tareas guardadas correctamente para {firstName} {lastName}',
    noteSavedSuccessfullyFor: 'Nota guardada correctamente para {firstName} {lastName}',
    errorLoadingNote: 'No se pudo cargar la nota. Por favor inténtalo de nuevo.',
    coaching: {
      contact: 'Habla sobre los grandes beneficios de la oportunidad y comparte tu historia personal de cómo TPC ha enriquecido tu vida.',
      email: 'Pega el siguiente enlace en un correo electrónico y envíalo a tu recluta\n{fullUrl}\nAsegúrate de decirle que ingrese tu ID de consultor cuando se le solicite durante el proceso de registro.',
      followup: 'Llama al prospecto para asegurarte de que reciba el contrato y responder cualquier pregunta que pueda tener.',
    },
    taskNames: {
      contact: 'Contactar a consultor potencial',
      email: 'Enviar por correo el enlace de inscripción al consultor potencial',
      followup: 'Llamada de seguimiento con el consultor potencial',
    },
  },
  errors: {
    loadingCountryCode: 'Error al cargar la información del país. Inténtalo de nuevo.',
    savingBankDetails: 'Error al guardar los datos bancarios. Inténtalo de nuevo.',
    updatingBusinessName: 'Error al actualizar el nombre del negocio. Inténtalo de nuevo.',
    businessNameAlreadyExists: 'El nombre del negocio ya existe. Por favor, elija otro.',
    savingFrenchContribution: 'Error al guardar la información de contribución francesa. Por favor, inténtelo de nuevo.',
    loadingFrenchContribution: 'Error al cargar la información de contribución francesa. Por favor, inténtelo de nuevo.',
    governmentIdInvalid: 'El número SSN o SIRET proporcionado es inválido. Por favor, verifique y corrija su información.',
    loadingContractTerms: 'Error al cargar los términos del contrato. Inténtalo de nuevo.',
    savingContractAgreement: 'Error al guardar el acuerdo contractual. Inténtalo de nuevo.',
    savingVatInformation: 'Error al guardar la información de IVA. Inténtalo de nuevo.',
    loadingVatInformation: 'Error al cargar la información de IVA. Inténtalo de nuevo.',
    wizardCompletionFailed: 'Error al registrar la finalización del asistente. Su cuenta ha sido configurada, pero hubo un problema con el paso final.',
    wizardCompletionRetry: 'No pudimos finalizar la configuración de su cuenta. Vuelva a intentarlo para completar este último paso.',
    loadingCampaignTypes: 'Error al cargar los tipos de campañas de marketing. Inténtalo de nuevo.',
    userNotAuthenticatedOrInvalidBeeNumber: 'Usuario no autenticado o número BEE inválido',
    userNotAuthenticatedOrInvalidBusinessGuid: 'Usuario no autenticado o GUID de negocio inválido',
    failedToSaveBankDetails: 'Error al guardar los datos bancarios',
    failedToSaveFrenchContributionData: 'Error al guardar los datos de contribución francesa',
    unableToGetAuthenticatedUserBeeNumber: 'No se puede obtener el número BEE del usuario autenticado',
    noShippingAddressFoundInAddressBookEntry: 'No se encontró dirección de envío en la entrada de la agenda',
    noAddressBookEntryFoundForHostEmail: 'No se encontró entrada de agenda para el correo electrónico del anfitrión',
    unableToGetBeeNumber: 'No se puede obtener el número BEE',
    noReportIdSpecified: 'No se especificó ID de informe',
    noConsultantDataReceived: 'No se recibieron datos del consultor',
    invoiceIsCanceled: 'La factura está cancelada',
    missingBeeNumberToken: 'Falta el token de verificación del correo electrónico.',
  },
  messages: {
    bankDetailsSaved: 'Sus datos bancarios se han guardado correctamente.',
    wizardCompleted: '¡Configuración de cuenta completada con éxito!',
    businessNameUpdated: 'El nombre de su negocio ha sido actualizado con éxito.',
    frenchContributionSaved: 'Su información de contribución francesa se ha guardado correctamente.',
    contractAgreementSaved: 'Su acuerdo contractual se ha guardado correctamente.',
    vatInformationSaved: 'Su información de IVA se ha guardado correctamente.',
    emailAddressVerified: 'Gracias por verificar su dirección de correo electrónico.',
  },
  actions: {
    TryAgain: 'Intentar de nuevo',
    Save: 'Guardar',
    UpdateBusinessName: 'Actualizar Nombre del Negocio',
    AcceptAndContinue: 'Aceptar y continuar',
  },
  routes: {
    CountryList: 'Lista de Países',
    CountryEdit: 'Editar País',
    DocumentTemplateList: 'Lista de Plantillas de Documentos',
    DocumentTemplateEdit: 'Editar Plantilla de Documento',
    DocumentTemplateCultureSpecificList:
      'Lista de Plantillas de Documentos Específicas de Cultura',
    DocumentTemplateCultureSpecificEdit:
      'Editar Plantilla de Documento Específica de Cultura',
    Home: 'Inicio',
    Logout: 'Cerrar Sesión',
    LocaleChanger: 'Cambiador de Localidad',
    Setup: 'Configuración',
    StateList: 'Lista de Estados',
    StateEdit: 'Editar Estado',
    Welcome: 'Bienvenido',
    Checkout22: 'Checkout 21',
  },
  accessibility: {
    required: 'requerido',
  },
  buttons: {
    Back: 'Atrás',
    Continue: 'Continuar',
    Okay: 'Aceptar',
    Edit: 'Editar',
    Delete: 'Eliminar',
    Yes: 'Sí',
    No: 'No',
    Add: 'Agregar',
    Filter: 'Filtrar',
    Clear: 'Limpiar',
    Apply: 'Aplicar',
    Save: 'Guardar',
    Exit: 'Salir',
    StateList: 'Lista de Estados',
    DocumentTemplateCultureSpecificList:
      'Lista de Plantillas de Documentos Específicas de Cultura',
    Html: 'Html',
    Raw: 'Crudo',
    ShowMore: 'Mostrar Más Resultados',
    UseCoupon: 'Usar un cupón',
    ApplyCoupon: 'Aplicar cupón',
    RemoveCoupon: 'Quitar cupón ({0})',
    CareerPlan: 'Plan de carrera',
    MyParties: 'Mis fiestas',
    TrainingVideos: 'Videos de formación',
    MyTeam: 'Resumen del equipo',
    AddCardToWallet: 'Agregar tarjeta a la billetera',
    Cancel: 'Cancelar',
    Close: 'Cerrar',
    Previous: 'Anterior',
    Next: 'Siguiente',
    Retry: 'Reintentar',
  },
  labels: {
    Actions: 'Acciones',
    Add: 'Agregar',
    AddToCart: 'Comprar',
    Filter: 'Filtrar',
    GridNoRecords: 'No se encontraron registros',
    DropDownListPlaceholder: 'Seleccione un {value}',
    CardHolderName: 'Nombre del titular de la tarjeta',
    CardNumber: 'Número de tarjeta',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    Success: '¡Éxito!',
    SelectOption: 'Seleccione una opción',
    SelectValue: 'Selecciona un valor',
    PricePerUnitWeight: {
      Weight: '{0} g',
      PricePerUnit: '({0}/kg)',
    },
    MonthToDate: 'Mes hasta la fecha',
    YearToDate: 'Año hasta la fecha',
    CustomRange: 'Rango personalizado',
    VatInformationHeader: 'Información de IVA',
    VatInformationSubHeader: 'Por favor proporcione su información de IVA para completar su registro',
    VatType: 'Tipo de número de IVA',
    VatNumber: 'Número de IVA',
    VatNumberPlaceholder: 'Introduzca su número de IVA (ej: FR12345678901)',
    VatNumberPlaceholderATDE: 'Introduzca su número de IVA (ej: DE123456789 o ATU12345678)',
    VatNumberHelp: 'El número de IVA debe comenzar con FR seguido de 11 caracteres',
    TaxIdNoInputRequired: 'No se requiere entrada para TAXID',
    LoadingVatInformation: 'Cargando información de IVA...',
    BusinessInfoHeader: 'Información del negocio',
    BusinessInfoSubHeader: 'Por favor proporcione la información de su negocio para completar su registro',
    BusinessName: 'Nombre del negocio',
    FrenchContributionHeader: 'Información de contribución francesa',
    FrenchContributionSubHeader: 'Proporcione la información requerida para la jurisdicción francesa',
    EmployeeStatus: 'Estado de empleado',
    SSN: 'Número de seguridad social',
    ContractAgreementHeader: 'Acuerdo de contrato de consultor',
    ContractAgreementSubHeader: 'Por favor, revise las prácticas comerciales y el código de ética a continuación antes de continuar',
    LoadingContractTerms: 'Cargando términos del contrato...',
    NoContractTerms: 'No hay términos contractuales disponibles',
    Saving: 'Guardando...',
    Updating: 'Actualizando...',
    SSNPlaceholder: 'Introduzca su número de seguridad social de 15 dígitos',
    SIRET: 'Número SIRET',
    SIRETPlaceholder: 'Introduzca su número SIRET',
    BirthCity: 'Ciudad de nacimiento',
    BirthCityPlaceholder: 'Introduzca su ciudad de nacimiento',
    BirthCountry: 'País de nacimiento',
    FrenchCitizen: 'Soy ciudadano francés',
    AuthorizedToWork: 'Estoy autorizado para trabajar en Francia',
    LoadingFrenchContribution: 'Cargando información de contribución francesa...',
    BusinessNamePlaceholder: 'Ingrese el nombre de su negocio',
    PersonalURL: 'URL de su sitio web personal',
    NewUserWizardHeader: 'Bienvenido a la Configuración de su Cuenta',
    NewUserWizardSubHeader: 'Por favor complete los siguientes pasos para configurar su cuenta',
    BankDetailsHeader: 'Información Bancaria',
    BankDetailsSubHeader: 'Por favor ingrese sus datos bancarios para recibir pagos de comisiones',
    BankAccountType: 'Tipo de Cuenta Bancaria',
    BankName: 'Nombre del Banco',
    BankNamePlaceholder: 'Ingrese el nombre de su banco',
    BIC: 'BIC (Código de Identificación Bancaria)',
    BICPlaceholder: 'Ingrese su código BIC',
    IBAN: 'IBAN',
    IBANPlaceholder: 'Ingrese su IBAN',
    DirectDeposit: 'Autorizo el depósito directo para pagos de comisiones',
    OPA: 'OPA (Opcional)',
    LoadingBankDetails: 'Cargando información bancaria...',
    CardExpirationDate: 'Fecha de expiración',
    CardSecurityCode: 'CVV',
    View: 'Ver',
    AutoCompleteLoading: 'Cargando...',
    AutoCompleteNoResults: 'No se encontraron resultados',
    CheckingInventory: 'Verificando inventario...',
    InStock: 'En stock',
    BirthDate: 'Fecha de nacimiento',
    Quantity: 'Cantidad',
    Okay: 'Aceptar',
    Error: 'Error',
    Loading: 'Cargando',
    Logout: 'Cerrar sesión',
    Search: 'Buscar',
    NoResultsFound: 'No se encontraron resultados',
    ShowMore: 'Mostrar más',
    ShowLess: 'Mostrar menos',
    Language: 'Idioma',
    ChooseLanguage: 'Seleccionar idioma',
    Country: 'País',
    ChooseCountry: 'Elige tu país',
    CreateAccount: 'Crear cuenta',
    RegistrationHeader: 'Crear una cuenta',
    SameAsBillingCheckbox: 'Usar esta dirección como mi información de facturación',
    CheckoutContinue: 'Continuar',
    CheckoutPlaceOrder: 'Realizar pedido',
    CheckoutReEnterAddress: 'Volver a ingresar la dirección',
    CheckoutUseSelectedAddress: 'Usar la dirección seleccionada',
    BecomeAConsultant: 'Conviértete en consultor',
    SearchForProduct: 'Usa el nombre del producto, SKU o palabra clave para buscar',
    SearchKeyword: 'Buscar por palabra clave',
    ExitImageOverlay: 'Haz clic en la imagen para alejar',
    MarketingOptIn: 'Tratamiento de datos con fines publicitarios',
    EmailMoreInfoCheckbox: 'Me gustaría recibir correos sobre productos, recetas, ofertas especiales y rebajas.',
    MarketingOptIn_NEWSLETTER_Content: '<span class="marketingconent"><p>Me gustaría recibir en el futuro por correo electrónico información sobre tendencias, descuentos, cupones, promociones y ofertas de Pampered Chef Austria.</p><br>    <p>Puedes revocar tu consentimiento para estas actividades en cualquier momento y de forma gratuita. Encontrarás más información sobre cómo procesamos tus datos personales y cómo puedes revocar tu consentimiento en nuestra política de privacidad.</p></span>',
    MarketingOptIn_MARKETING_Content: '<span class="marketingconent"><p>Me gustaría recibir en el futuro por correo electrónico información sobre tendencias, descuentos, cupones, promociones y ofertas de Pampered Chef Austria.</p><br>    <p>Puedes revocar tu consentimiento para estas actividades en cualquier momento y de forma gratuita. Encontrarás más información sobre cómo procesamos tus datos personales y cómo puedes revocar tu consentimiento en nuestra política de privacidad.</p></span>',
    SearchPlaceHolder: 'Buscar por nombre o código de producto',
    FreeProductQuantityPrefix: '{quantity}x ',
    SkuPrefix: 'SKU: {sku}',
  },
  alerts: {
    Success: '¡Éxito!',
    InvoiceChange: 'Acción sobre la factura',
    CancelInvoiceConfirm: '¿Está seguro de que desea cancelar esta factura?',
    ResendInvoiceConfirm: '¿Está seguro de que desea reenviar esta factura?',
    InvoiceCancelled: 'La factura se canceló correctamente.',
    InvoiceResent: 'La factura se reenvió correctamente.',
    FailedToCancelInvoice: 'No se pudo cancelar la factura. Inténtelo de nuevo.',
    FailedToResendInvoice: 'No se pudo reenviar la factura. Inténtelo de nuevo.',
    CannotCancelInvoice: 'Esta factura no se puede cancelar porque ya está cancelada o pagada.',
    CannotResendInvoice: 'Esta factura no se puede reenviar porque ya está cancelada o pagada.',
    AddedToCart: '¡Añadido al carrito!',
    AddToCartError: 'Error al añadir al carrito',
    NoQuantityAvailable: 'No hay suficiente en el almacén para añadir más al carrito',
    HostOnlyItemTitle: 'Artículo solo para anfitrión',
    HostOnlyItemMessage: 'Este artículo solo está disponible para los carritos de anfitrión y no se puede añadir a un carrito de invitado.',
    HostOnlyItemButton: 'Solo anfitrión',
    DiscountOnlyItemTitle: 'Artículo solo por descuento',
    DiscountOnlyItemMessage: 'Este artículo solo se puede añadir como parte de una recompensa de descuento y no manualmente.',
    DiscountOnlyItemButton: 'Solo descuento',
    DeleteConfirmTitle: 'Eliminar',
    DeleteConfirm: '¿Está seguro de que desea eliminar: {0}?',
    NoPermissions: 'No tiene permisos para realizar esta acción. ({0})',
    UnsavedChanges: 'Tiene cambios no guardados. ¿Desea guardarlos?',
    ProductEligibilityQuantityGatewayException: 'La cantidad máxima permitida para este producto es {ruleQuantity}.',
    ProductEligibilityOrderTotalGatewayException: 'El total del pedido {orderTotal} supera el límite del total del pedido de {orderTotalCap}.',
    PoeDiscCouponNotFoundException: 'El cupón que intenta usar no es válido.',
    PoeDiscCouponDiscountPlanNotFoundException: 'El cupón que intenta usar no es válido para este pedido.',
    SingleUseOrderLimitTitle: 'Límite de pedido alcanzado',
    SingleUseOrderLimitMessage: 'Ya ha realizado un pedido. Solo se permite un pedido de Kit Enhancement.',
    FailedToGetCurrentBatchNumber: 'No se pudo obtener el número de lote actual.',
    AOEInvoiceCartNotFoundException: 'Factura no encontrada',
    AOECartInvoiceStatusInvalidException: 'La factura ya no se puede pagar',
    PoeDiscCouponAlreadyUsedException: 'Este cupón ya ha sido utilizado y no se puede aplicar nuevamente',
    AOESkuExpiredException: "El SKU '{skuCode}' ya no está disponible. Por favor, elimínelo de su carrito para continuar con el pago.",
    CartSubmit: {
      UnknownError: 'El carrito no se pudo enviar debido a un error desconocido',
      NotBalanced: 'El carrito no se pudo enviar porque el carrito está desequilibrado',
      SkuWarehouseNotFound: 'El carrito no se pudo enviar porque no se encontró el almacén para {SkuCode}',
      SkuWarehouseNotAvailable: 'El carrito no se pudo enviar porque {SkuCode} no está disponible en el almacén',
      SkuWarehouseStopSell: 'El carrito no se pudo enviar porque {SkuCode} está agotado en el almacén',
      ProductNotEligibleForPurchase: 'El carrito no se pudo enviar porque {SkuCode} no está permitido para compra',
      CouponAlreadyUsed: 'Este cupón ya ha sido utilizado y no se puede aplicar nuevamente',
      ShippingAddressMissing: 'El carrito no se pudo enviar porque falta la dirección de envío',
      ShippingMethodMissing: 'El carrito no se pudo enviar porque falta el método de envío',
    },
    CartSubmitSuccessTitle: '¡Éxito!',
    CartSubmitSuccess: 'Su carrito ha sido enviado'
  },
  address: {
    AddressLines: 'Dirección',
    City: 'Ciudad',
    Country: 'País',
    Name: 'Nombre',
    NameRequired: 'El nombre es obligatorio',
    PostalCode: 'Código Postal',
    State: 'Estado/Provincia',
    Street2: 'Línea de Dirección 2',
    HouseNumber: 'Número de Casa',
    Street: 'Calle',
  },
  accountInfo: {
    personalData: {
      title: 'Solicitar datos personales',
      description: 'Solicita una copia de tus datos personales o solicita la eliminación',
      updateTitle: 'Solicitud de datos personales',
      updateDescription: 'Solicita tus datos personales o la eliminación de tu cuenta. Procesaremos tu solicitud de acuerdo con las leyes de privacidad aplicables.',
      selectRequest: 'Selecciona tu solicitud:',
      exportData: 'Exportar datos personales',
      deleteData: 'Eliminar datos personales',
      emailAddress: 'Tu correo electrónico (requerido):',
      emailPlaceholder: 'Ingresa tu correo electrónico',
      sendRequest: 'Enviar solicitud',
      emailRequired: 'El correo electrónico es requerido',
      emailInvalid: 'Por favor ingresa un correo electrónico válido',
      emailMismatch: 'El correo electrónico ingresado es inválido.',
      optionRequired: 'Por favor selecciona una opción de solicitud',
      exportSuccess: 'Tu solicitud de exportación de datos se envió correctamente. Ahora puedes descargar tu reporte en PDF.',
      deleteSuccess: 'Tu solicitud de eliminación de datos se envió correctamente.',
      submitError: 'No se pudo enviar la solicitud. Por favor inténtalo de nuevo.',
      exportOptionsTitle: 'Tu exportación de datos personales',
      exportOptionsDescription: 'Tu solicitud de exportación de datos ha sido procesada. Puedes descargar el reporte como PDF.',
      downloadPDF: 'Descargar reporte PDF',
      viewReport: 'Ver reporte',
      reportTitle: 'Reporte de exportación de datos personales',
      newRequest: 'Hacer una nueva solicitud',
      pdfNoProfileDataError: 'No hay datos de perfil disponibles. Por favor envía la solicitud de nuevo.',
      pdfNoAddressDataError: 'Los datos de dirección no se cargaron. Por favor envía la solicitud de nuevo.',
      pdfComponentNotReadyError: 'El componente de exportación PDF no está listo. Por favor inténtalo de nuevo.',
      pdfDownloadFailedError: 'La descarga del PDF falló. Por favor inténtalo de nuevo o usa la función de imprimir del navegador.',
      reportHeader: 'Exportación de datos personales',
      businessInformation: 'Información de negocio:',
      personalInformation: 'Información personal:',
      contactInformation: 'Información de contacto:',
      phoneNumbers: 'Números de teléfono:',
      addresses: 'Direcciones:',
      governmentIds: 'Identificaciones gubernamentales:',
      governmentIdType: 'Tipo de identificación:',
      taxPayerIdLastFour: 'Últimos cuatro dígitos:',
      noGovernmentIdsOnFile: 'No hay identificaciones registradas.',
      customerNumber: 'Número de cliente:',
      dateOfBirth: 'Fecha de nacimiento:',
      username: 'Nombre de usuario:',
      anniversary: 'Aniversario:',
      name: 'Nombre:',
      social: 'Redes sociales:',
      firstName: 'Nombre:',
      lastName: 'Apellido:',
      preferredName: 'Nombre preferido:',
      alternativeFirstName: 'Nombre alternativo:',
      alternativeLastName: 'Apellido alternativo:',
      webUrl: 'URL Web:',
      imHandle: 'Usuario de IM:',
      facebook: 'Facebook:',
      twitter: 'Twitter:',
      linkedIn: 'LinkedIn:',
      pinterest: 'Pinterest:',
      reportEmailAddress: 'Correo electrónico:',
      home: 'Casa',
      mobile: 'Móvil',
      fax: 'Fax',
      work: 'Trabajo',
      shippingAddress: 'Dirección de envío',
      billingAddress: 'Dirección de facturación',
      mailingAddress: 'Dirección postal',
      addressName: 'Nombre:',
      company: 'Empresa:',
      addressLine1: 'Dirección línea 1:',
      addressLine2: 'Dirección línea 2:',
      city: 'Ciudad:',
      stateProvince: 'Estado/Provincia:',
      postalCode: 'Código postal:',
      country: 'País:',
      noAddressesOnFile: 'No hay direcciones registradas.',
      reportFooterText: 'Reporte de exportación de datos personales - generado el',
      requestType: 'Tipo de solicitud: exportación de datos',
      notAvailable: 'N/D'
    },
  },
  columns: {
    birthDate: 'Fecha de Nacimiento',
    birthDatePlaceholder: 'Día/Mes/Año',
    countryCode: 'Código de País',
    country: 'Nombre del País',
    currencyId: 'Moneda',
    stateCode: 'Código de Estado',
    state: 'Nombre del Estado',
    countryCodeIsoalpha3: 'ISO 3',
    isEnabled: 'Habilitado',
    templateName: 'Nombre de la Plantilla',
    templateDescription: 'Descripción',
    schemaName: 'Nombre del Esquema',
    cultureName: 'Nombre de la Cultura',
    messageBody: 'Cuerpo del Mensaje',
    documentName: 'Nombre del Documento',
    documentSubject: 'Asunto del Documento',
    codeIdClassification: 'Clasificación',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    phoneNumber: 'Número de Teléfono',
    facebookId: 'Facebook',
    linkedInId: 'LinkedIn',
    twitterId: 'Twitter',
    pinterestId: 'Pinterest',
  },

  cart: {
    CartHeader: 'Tu Carrito',
    Select: 'Seleccionar',
    Checkout: 'Verificar',
    ApplePayCheckout: 'Pagar con',
    ApplePayImageAlt: 'Apple Pay',
    CompleteSet: 'Completa tu Conjunto',
    ConnectHeader: 'Conéctese con una parte o un consultor',
    ConnectSubHeader: '¿No conoces un consultor? Encuentre uno en su área para apoyar al propietario de un negocio local.',
    ConsultantByName: 'Por nombre',
    ConsultantByLocation: 'Por ubicación',
    ConsultantListHeader: 'Consultores cerca de ti',
    ContinueShopping: 'SEGUIR COMPRANDO',
    FindConsultatHeader: 'Encontrar una consultora',
    FindConsultatSubHeader: 'Ingrese el nombre y apellido de su consultor, o busque un consultor cerca de usted.',
    FindParty: 'ENCUENTRA UNA FIESTA',
    FindPartyHeader: 'Encuentra una Fiesta',
    FindPartyConsultant: 'Encuentra una fiesta con tu consultor',
    FindPartySubHeader: 'Ingrese el anfitrión de la fiesta, el nombre del presidente o el nombre de la organización.',
    GuestCheckout: 'Pago de invitado',
    GuestCheckoutSubHeader: 'Puede realizar el pago como invitado y crear una cuenta más tarde.',
    HostedBy: 'Anfitrión',
    InterestedInHosting: '¿Interesada en organizar una fiesta?',
    InterestedInHostingLink: 'Más información',
    NoFreeGift: 'No gracias, no quiero un regalo gratis',
    NotOrderWithConsultant: 'No estoy ordenando con un partido o consultor',
    NotSupported: 'No compatible',
    OrderingWith: 'Estas ordenando con',
    OrderSummary: 'Resumen del pedido',
    PlaceHolderConsultantName: 'Ingrese el nombre del consultor',
    PlaceHolderHost: 'Ingrese el nombre del anfitrión, presidente u organización de la fiesta',
    PlaceholderZipcode: 'Introduce un código postal',
    RelatedProducts: 'Productos que te pueden gustar',
    RemoveParty: 'Eliminar grupo',
    RemoveConsultant: 'Eliminar Consultor',
    SelectButton: 'Seleccionar',
    SelectedFreeGift: 'Seleccionada',
    Shipping: 'Envío',
    SignIn: 'Iniciar sesión',
    SignInSubHeader: 'Inicie sesión para realizar un pago más rápido y aplicar sus descuentos y/o créditos.',
    Subtotal: 'Total parcial',
    SystemKeyword: 'SystemKeyword',
    TaxCalc: 'Impuesto calculado al finalizar la compra',
    Total: 'Total',
    ProductTotal: 'Total de productos',
    DiscountTotal: 'Descuento',
    UnderParty: 'Baja',
    ViewCart: 'Carro',
    WhereParty: 'Dónde',
    MustSelectPartyOrConsultant: 'Debe seleccionar una fiesta o consultor para continuar.',
    MustSelectFreeProductOrOptOut: 'Por favor seleccione su producto gratis u opte por no recibirlo antes de continuar.',
    ShowFreeGift: 'Mostrar Regalos Gratis',
    EmptyCart: 'Tu carrito está vacío',
    EmptyCartMessage: 'Comienza a agregar productos a tu carrito para verlos aquí.',
    CloseCart: 'Cerrar carrito',
    ProductImageAlt: 'Imagen del producto',
    ConsultantPhotoAlt: 'Foto del consultor',
    RemoveFromCart: 'Eliminar del carrito',
    ItemRemovedFromCart: "'{skuName}' ha sido eliminado de su carrito.",
    warnings: {
      SkuShippingRestriction: "El SKU '{SkuCode}' no está disponible para el método de envío seleccionado",
      RESTRICTED_ITEM: 'Algunos artículos en su carrito tienen restricciones.',
      INVALID_SHIPPING_METHOD: 'El método de envío seleccionado no está disponible para su dirección.',
      MINIMUM_ORDER_NOT_MET: 'Su pedido no cumple con el requisito de pedido mínimo.',
    },
  },
  checkout: {
    AddressRequirementMessage: 'Los campos marcados con un asterisco (*) son obligatorios.',
    Checkout: 'Checkout',
    KitCheckout: 'Completar registro',
    CheckoutAddressValAddressEntered: 'Dirección ingresada:',
    CheckoutAddressValError: 'No se pudo verificar la dirección. Vuelve a ingresar tu dirección o continúa con la dirección ingresada.',
    CheckoutAddressValHdr: 'No pudimos verificar la dirección que ingresaste.',
    CheckoutAddressValSubHdr: 'Selecciona una dirección de la lista a continuación o edita tu dirección.',
    CheckoutAddressValVerifiedAddress: 'Opciones de dirección verificada:',
    CheckoutAddressValWarning: 'Debes seleccionar una dirección verificada para continuar.',
    CheckoutEditStep: 'Editar',
    CheckoutPaymentHdrStep: '3. Pago',
    CheckoutOrderSummaryHdr: 'Resumen del pedido',
    CheckoutShipping: 'Envío',
    CheckoutShippingHdrStep: '2. Envío',
    CheckoutSubHeader: 'Inicia sesión para un checkout más rápido y para aplicar tus descuentos y/o créditos.',
    CheckoutSubHeaderRemainder: 'para un checkout más rápido y para aplicar tus descuentos y/o créditos.',
    CheckoutSubtotal: 'Subtotal',
    CheckoutTax: 'Impuesto',
    CheckoutTotal: 'Total',
    CheckoutTotalRegularPrice: 'Precio Total Regular',
    CheckoutYourInformationHdrStep: '1. Tu información',
    CreditCartHeader: 'Información de la tarjeta de crédito',
    CreditCartSubmit: 'Enviar',
    OrderSummaryYourOrder: 'Tu pedido',
    OrderSummaryItem: 'Artículos',
    PaymentAmount: 'Importe a cobrar:',
    NotSuppoted: 'no es compatible',
    OrderNumber: 'Número de pedido',
    Quantity: 'Cantidad',
    paymentMethods: {
      TTGBraintree: 'Tarjeta de crédito',
      TTGBraintreeAPM: 'EPS',
      TTGBraintreeFR: 'Tarjeta de crédito',
      TTGBraintreeAT: 'Tarjeta de crédito',
      TTGBraintreeDE: 'Tarjeta de crédito',
      OPA: 'OPA',
      PayPal: 'PayPal',
      EPS: 'EPS',
    },
    transactionStates: {
      NotProcessed: 'Autorizado',
      PreAuthorized: 'Pre-autorizado',
      Authorized: 'Autorizado',
      Booked: 'Reservado',
      Refunded: 'Reembolsado',
      Processed: 'Procesado',
    },
  },
  productReview: {
    AddReviewButton: 'Agregar Reseña',
    EditReviewButton: 'Editar Reseña',
    CompleteHeader: '¡Gracias!',
    CompleteSubHeader: 'Su reseña ha sido enviada y se publicará una vez aprobada.',
    CreateReview: 'Crear Reseña',
    ErrorHeader: '¡Error!',
    ErrorFileSize: 'Por favor verifique el tamaño de los archivos que está adjuntando, tal vez sean demasiado grandes.',
    ErrorLoggedIn: 'Debes iniciar sesión para crear una reseña',
    ErrorReviewComment: 'Se requiere comentario',
    ErrorOverallRating: 'Se requiere calificación',
    ErrorSubHeader: 'Su reseña no ha sido enviada.',
    OverallRating: 'Calificación General',
    Review5Star: 'Excelente',
    Review4Star: 'Bueno',
    Review3Star: 'Promedio',
    Review2Star: 'Por Debajo del Promedio',
    Review1Star: 'Pobre',
    ReviewAnonymous: 'Haga que la reseña aparezca como anónima; si no se marca, su nombre se mostrará con su reseña',
    ReviewAttachment: 'Añade una foto o un vídeo',
    ReviewByAnonymous: 'Anónimo',
    ReviewComment: 'Añadir una reseña escrita',
    ReviewHeader: 'Reseñas de Clientes',
    ReviewPending: 'Revisión pendiente de aprobación',
    ReviewSubmit: 'Enviar Reseñas',
    ReviewTotalPart1: 'de',
    ReviewTotalPart2: 'reseñas',
    CommentPlaceholder: '¿Qué le gustó o no le gustó? ¿Para qué usó este producto?',
    ReviewImageAlt: 'Imagen de reseña de producto',
    ClickToUpload: 'Haz clic para seleccionar archivos o arrástralos aquí',
    SupportedFormats: 'JPEG, PNG, JPG, GIF, MP4',
    RemoveFileTitle: 'Eliminar archivo',
    Uploaded: 'Subido',
    Failed: 'Falló',
    ExistingAttachments: 'Fotos y videos actuales',
    DeleteAttachment: 'Eliminar este archivo adjunto',
    Delete: 'Eliminar',
    DeleteAttachmentConfirm: '¿Está seguro de que desea eliminar este archivo adjunto? Esta acción no se puede deshacer.',
    ErrorDeletingAttachment: 'Error al eliminar el archivo adjunto. Por favor, inténtelo de nuevo.',
  },
  wishList: {
    CancelButton: 'Cancelar',
    CreateList: 'Crear una lista',
    CreateListButton: 'Crear Lista',
    PageHeader: 'Mi Lista',
    PlaceHolderWishListName: 'Introduzca un nombre para su lista',
    WishListButton: 'Mi Lista de Deseos',
    WishListDetailHeader: 'Mis listas de Deseos',
    WishListHeader: 'Mi Lista de Deseos',
    WishListItems: 'Elementos',
    WishListSaveTo: 'Guardar en',
    RemoveFromWishlist: 'Eliminar de la lista de deseos',
  },
  partyOrderEntry: {
    ProductSubtotalByCategory: 'Subtotal de Productos por Categoría',
    PriceCategoryName: 'Categoría',
    SumTotalPrice: 'Precio Total',
    Discount: 'Descuento %',
    FinalSum: 'Suma Final',
    BuyingDiscount: 'Descuento de Compra',
    OrderNumberHeader: 'N.º de pedido',
    ViewOrderReceipt: 'Ver el recibo del pedido'
  },
  invoice: {
    CartNumber: 'Número de carrito',
    Name: 'Nombre',
    Email: 'Correo electrónico',
    Phone: 'Teléfono',
    EventName: 'Nombre del evento',
    InvoiceHeader: 'Pago de factura',
    InvoiceInstruction: 'Pague el saldo restante de la factura de su pedido. <br/>Revise su factura a continuación y use el botón Agregar pago para seleccionar un método de pago.',
    InvoiceNumber: 'Número de factura',
    OrderDate: 'Fecha del pedido',
    OrderInformation: 'Información del pedido',
    OrderReference: 'Referencia del pedido',
    ShippingAddress: 'Dirección de envío',
    SubmitButton: 'Enviar pago',
    EmailLabel: 'Dirección de correo electrónico',
    EmailPlaceholder: 'Ingrese su dirección de correo electrónico',
    VerifyIdentityButton: 'Verificar identidad',
    InvoiceNotFound: 'Factura no encontrada. Verifique el número de factura e intente nuevamente.',
    VerifyIdentityInstruction: 'Ingrese su dirección de correo electrónico para verificar su identidad y acceder a esta factura.',
    VerifyIdentityFailed: 'La dirección de correo electrónico no coincide con nuestros registros. Intente nuevamente.'
  },
  consultantOrderEntry: {
    CartSummaryHeader: 'Resumen del carrito',
    ProceedToCheckout: 'Proceder al pago',
    SubmitButton: 'Enviar',
    ContinueShoppingButton: 'Continuar comprando'
  },
  consultantLocator: {
    welcomeHeader: "¡Estamos aquí para apoyarte!",
    teamJoiningHeader: "¿A qué equipo te unirás?",
    searchByText: "Busca tu consultor por:",
    nameTab: "Nombre",
    locationTab: "Ubicación",
    country: "País",
    directSignupText: "¿No conoces a ningún consultor o simplemente quieres registrarte directamente con la oficina principal? Marca la casilla.",
    directSignupError: "No se pudo procesar el registro directo. Inténtalo de nuevo o contacta con soporte.",
    whyJoinConsultantQuestion: "¿Por qué necesitas unirte con un consultor?",
    whyJoinConsultantPersonal: "¿Por qué necesito unirme con un consultor?",
    consultantTeamInfo: "Cuando seleccionas un consultor para unirte a su equipo, ellos te guiarán y te brindarán apoyo invaluable para alcanzar tus metas como consultor.",
    experienceInfo: "Queremos asegurarnos de que tengas una buena experiencia al registrarte con Pampered Chef. Podemos usar tu información de contacto (o compartirla con tu consultor) para comunicarnos y ayudarte en tu camino.",
    selectDifferentConsultant: "Seleccionar un consultor diferente",
    selectAndContinue: "Seleccionar y continuar",
    consultantsFound: "Consultores encontrados",
    noConsultantsFound: "No se encontraron consultores en esta área. Prueba con otro código postal.",
    enterConsultantName: "Ingresa nombre o apellido",
    enterZipCode: "Ingresa código postal",
    searchRadius: "Radio de búsqueda",
    kilometers: "km"
  },
  eventList: {
    AddHost: 'Agregar el Anfitrión',
    AtHostAddress: 'En la Dirección del Anfitrión',
    AtNewAddress: 'En una Dirección Diferente',
    CancelButton: 'Cancelar',
    PreviousButton: 'Anterior',
    ClosedEventButton: 'Cerrados',
    CreateEventButton: 'Crear Evento',
    CreateNewEvents: 'Crear Nuevo Evento',
    EmailAddress: 'Dirección de Correo',
    EventAddressError: 'La dirección del evento es requerida',
    EventCommission: 'Comisión',
    EventConsultantError: 'Tu sesión ha expirado, por favor inicia sesión nuevamente',
    EventDate: 'Fecha',
    EventDateError: 'La fecha del evento es requerida',
    EventTimeError: 'La hora de inicio no puede ser después de la hora de fin',
    EventPastDateError: 'El evento no puede programarse en el pasado',
    EventHostAddError: 'El nombre, apellido, correo y teléfono del anfitrión son requeridos',
    HostInfoError: 'Por favor complete el nombre, apellido del anfitrión y ya sea el teléfono o el correo',
    HostAddressError: 'Por favor complete todos los campos de dirección del anfitrión',
    EventHostess: 'Anfitrión',
    EventId: 'Evento',
    EventLocation: 'Ubicación',
    EventEndTime: 'Fin',
    EventStartTime: 'Inicio',
    EventTitle: 'Nombre',
    EventTitleError: 'El nombre del evento es requerido',
    EventTotal: 'Total',
    FindHost: 'Buscar el Anfitrión',
    FindHostError: 'Por favor selecciona un anfitrión',
    FirstName: 'Nombre',
    HostAddress: 'Dirección del Anfitrión',
    HostInformation: 'Información del Anfitrión',
    IAmHost: 'Soy el anfitrión',
    LastName: 'Apellido',
    MyEvents: 'Mis Eventos',
    NewEventButton: 'Nuevo Evento',
    NewEventStep1: 'Paso 1: Elige el tipo de evento que deseas crear',
    NewEventStep2: 'Paso 2: Elige el país en el que se llevará a cabo el evento',
    NewEventStep3: 'Paso 3: Elige el anfitrión del evento',
    NewEventStep4: 'Paso 4: Elige el título y la hora del evento',
    NewEventStep5: 'Paso 5: Elige la ubicación del evento',
    NewEventStep6: '¿Qué te gustaría hacer a continuación?',
    SaveAndFinish: 'Guardar y Finalizar',
    SaveAndFinishDescription: 'Guarda el evento en tu calendario y regresa a tu página de cuenta.',
    HostPortal: 'Portal del Anfitrión',
    HostPortalDescription: 'Guarda el evento y ve al Portal del Anfitrión. Elige un tema y envía un correo al anfitrión con los datos de acceso.',
    InviteGuests: 'Invitar Invitados',
    InviteGuestsDescription: 'Guarda el evento y ve a la gestión de invitados para agregar invitados al evento.',
    NextButton: 'Siguiente',
    OpenEventButton: 'Abiertos',
    PhoneNumber: 'Número de Teléfono',
    SearchButton: 'Buscar',
    SearchHost: 'Busca en tu Libreta de Direcciones por nombre, apellido, correo o número de teléfono',
    EventStatus: 'Estado',
    SearchEvents: 'Buscar eventos por nombre, ID o anfitrión...',
    ClearSearch: 'Limpiar Búsqueda',
    NoEventsFound: 'No se encontraron eventos',
  },
  eventTypes: {
    Party: 'Fiesta',
    InPersonEvent: 'Evento presencial',
    FacebookParty: 'Fiesta de Facebook',
    WhatsAppParty: 'Fiesta de WhatsApp',
    Unknown: 'Desconocido',
  },
  consultantCorner: {
    Back: 'Atrás',
    MyAccount: 'Mi cuenta',
    myAccountRenewalReminder: {
      message: 'Tu plan actual termina en {days} días. Revisa ahora la configuración de tu renovación.',
      messageToday: 'Tu plan actual expira hoy. Revisa ahora la configuración de tu renovación.',
      messageExpired: 'Tu plan actual ha finalizado. Revisa ahora la configuración de tu renovación.',
      trialMessage: 'Tu período de prueba termina en {days} días. Revisa ahora la configuración de tu renovación.',
      trialMessageToday: 'Tu período de prueba expira hoy. Revisa ahora la configuración de tu renovación.',
      trialMessageExpired: 'Tu período de prueba ha finalizado. Revisa ahora la configuración de tu renovación.',
      action: 'Ir a Configuración de Tienda Web',
      dismiss: 'Cerrar'
    },
    SelectSection: 'Seleccionar sección',
    ClassId: 'Clase',
    ContactDetails: 'Datos de contacto',
    Address: 'Dirección',
    VATLiability: 'Responsabilidad del IVA',
    UploadPhoto: 'Subir foto',
    MyStory: 'Mi historia',
    WebshopSettings: 'Configuración de la tienda web',
    SocialMedia: 'Redes sociales',
    Facebook: 'Facebook',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    YouTube: 'YouTube',
    TikTok: 'TikTok',
    SocialMediaDescription: 'Agrega enlaces a tus cuentas profesionales de redes sociales',
    security: {
      passwordHeader: 'Cambiar Contraseña',
      passwordSubHeader: 'Actualiza la contraseña de tu cuenta para mayor seguridad',
      oldPasswordLabel: 'Contraseña Actual',
      oldPasswordPlaceholder: 'Ingresa tu contraseña actual',
      newPasswordLabel: 'Nueva Contraseña',
      newPasswordPlaceholder: 'Ingresa tu nueva contraseña',
      confirmPasswordLabel: 'Confirmar Nueva Contraseña',
      confirmPasswordPlaceholder: 'Confirma tu nueva contraseña',
      passwordRequirements: 'Requisitos de Contraseña:',
      requirement1: 'Al menos 8 caracteres de longitud',
      requirement2: 'Al menos una letra minúscula',
      requirement3: 'Al menos una letra mayúscula',
      requirement4: 'Al menos un número',
      requirement5: 'Al menos un carácter especial',
      savePassword: 'Guardar Contraseña',
      saving: 'Guardando...',
      oldPasswordRequired: 'La contraseña actual es requerida',
      newPasswordRequired: 'La nueva contraseña es requerida',
      newPasswordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      newPasswordWeak: 'La contraseña no cumple con los requisitos',
      newPasswordSameAsCurrent: 'La nueva contraseña debe ser diferente de la contraseña actual',
      confirmPasswordRequired: 'Por favor confirma tu nueva contraseña',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordSaveSuccess: 'Contraseña actualizada exitosamente',
      passwordSaveError: 'Error al actualizar la contraseña. Inténtalo de nuevo.'
    },
    contactDetails: {
      ContactDetails: 'Detalles de Contacto',
      UpdateContactInfo: 'Actualiza tu información de contacto',
      PageLoadError: 'Error al cargar los detalles de contacto',
      SaveError: 'Error al guardar la información de contacto',
      SaveErrorGeneric: 'Ocurrió un error inesperado al guardar tu información de contacto. Por favor, inténtalo de nuevo.',
      SaveSuccess: 'Información de contacto guardada exitosamente',
      NetworkError: 'Error de red. Por favor, verifica tu conexión e inténtalo de nuevo.',
      ValidationError: 'Por favor, corrige los errores de validación e inténtalo de nuevo.',
      TryAgain: 'Intentar de Nuevo',
      LoadingContactDetails: 'Cargando detalles de contacto...',
      CancelButton: 'Cancelar',
      SaveContactInfo: 'Guardar Información de Contacto',
      Saving: 'Guardando...',
      AccountInfo: 'Información de Cuenta',
      Username: 'Nombre de Usuario',
      NameSection: 'Información del Nombre',
      FirstName: 'Nombre',
      LastName: 'Apellido',
      ContactInfo: 'Información de Contacto',
      EmailAddress: 'Dirección de Correo',
      PrimaryPhone: 'Teléfono Fijo',
      MobilePhone: 'Móvil',
      PhonePlaceholder: 'Ingresa número de teléfono',
      FirstNameRequired: 'El nombre es requerido',
      LastNameRequired: 'El apellido es requerido',
      EmailRequired: 'La dirección de correo es requerida',
      EmailInvalid: 'Por favor ingresa una dirección de correo válida',
      PhoneInvalid: 'Por favor ingresa un número de teléfono válido'
    },
    leads: {
      MyLeads: 'Mis Leads',
      AllLeads: 'Todos los Leads',
      leadCount: '{count} Leads',
      LeadSubHeader: 'Revisa y gestiona tus leads',
      FirstName: 'Nombre',
      LastName: 'Apellido',
      Email: 'Correo Electrónico',
      Phone: 'Teléfono',
      CreateDate: 'Fecha de Creación',
      Status: 'Estado',
      Source: 'Fuente',
      searchPlaceholder: 'Buscar leads...',
      Loading: 'Cargando...',
      Actions: 'Acciones',
      Accept: 'Aceptar',
      Reject: 'Rechazar',
      Refer: 'Referir',
      ReferTo: 'Referir a',
      SelectConsultant: 'Seleccionar Consultor',
      NoConsultantsFound: 'No se encontraron consultores',
      ConfirmAccept: '¿Estás seguro de que deseas aceptar este lead?',
      ConfirmReject: '¿Estás seguro de que deseas rechazar este lead?',
      ConfirmRefer: '¿Estás seguro de que deseas referir este lead al consultor seleccionado?',
      LeadAccepted: 'Lead aceptado exitosamente',
      LeadRejected: 'Lead rechazado exitosamente',
      LeadReferred: 'Lead referido exitosamente',
      Cancel: 'Cancelar',
      Confirm: 'Confirmar',
      NoLeads: 'No se encontraron leads para este contacto.',
      LeadType: 'Tipo de Lead',
      DistSource: 'Fuente de Distribución',
      AssignedDate: 'Fecha de Asignación',
      Accepted: 'Aceptado',
      Closed: 'Cerrado',
      Open: 'Abierto'
    },
    editContact: {
      PageLoadError: 'Se produjo un error al cargar los detalles del contacto.',
      EditContact: 'Editar Contacto',
      EditContactDetails: 'Edita los detalles del contacto aquí',
      Name: 'Nombre',
      SaveButton: 'Guardar',
      CancelButton: 'Cancelar',
      SelectTab: 'Seleccionar pestaña',
      SameAsBilling: 'Igual que la Dirección de Facturación',
      ShippingAddress: 'Dirección de Envío',
      BillingAddress: 'Dirección de Facturación',
      SameAsShipping: 'Igual que la dirección de envío',
      Email: 'Dirección de Correo',
      PrimaryPhone: 'Número de Teléfono Principal',
      AltPhone: 'Número de Teléfono Alternativo',
      General: 'General',
      Lead: 'Lead',
      Tasks: 'Tareas',
      Notes: 'Notas',
      Orders: 'Pedidos',
      Activity: 'Actividad',
      AdditionalInformation: 'Información Adicional',
      SocialMedia: 'Redes Sociales',
      Communication: 'Comunicación',
      PhoneCountry: 'País',
      PhoneType: 'Tipo de Teléfono',
      NoEmail: 'No hay Dirección de Correo Disponible',
      OrderId: 'ID de Pedido',
      OrderTime: 'Fecha',
      OrderStatus: 'Estado',
      OrderTotal: 'Total',
      HostName: 'Nombre del Anfitrión',
      EventDate: 'Fecha del Evento',
      ViewOrders: 'Ver Pedidos',
      Order: 'Crear Pedido',
      ClickViewOrders: 'Haz clic en Ver Pedidos para cargar la tabla',
      OrderSummary: 'Resumen del Pedido',
      PersonalInformation: 'Información Personal',
      Language: 'Idioma',
      BirthDate: 'Fecha de Nacimiento',
      Misc: 'Varios',
      Group: 'Grupo',
      HowDidYouHear: 'Cómo te enteraste de nosotros',
      AddNotes: 'Agregar Nota',
      SaveSuccess: '¡Éxito!',
      SaveError: 'Error',
      ContactUpdatedSuccessfully: 'El contacto se ha actualizado correctamente.',
      ContactUpdateFailed: 'No se pudo actualizar el contacto. Por favor, inténtalo de nuevo.',
      AdditionalInfoUpdatedSuccessfully: 'La información adicional se ha actualizado correctamente.',
      AdditionalInfoUpdateFailed: 'No se pudo actualizar la información adicional. Por favor, inténtalo de nuevo.',
      SocialMediaUpdatedSuccessfully: 'La información de redes sociales se ha actualizado correctamente.',
      SocialMediaUpdateFailed: 'No se pudo actualizar la información de redes sociales. Por favor, inténtalo de nuevo.',
      RequiredFieldsMissing: 'Por favor, completa todos los campos requeridos antes de guardar.',
      ShippingAddressFieldsRequired: 'Por favor, completa todos los campos requeridos de la dirección de envío.',
      BillingAddressFieldsRequired: 'Por favor, completa todos los campos requeridos de la dirección de facturación.',
      PhoneRequired: 'Por favor, ingresa un número de teléfono principal.',
    },
    tabs: {
      TasksContent: 'Contenido de tareas próximamente.',
      ActivityContent: 'Contenido de actividad próximamente.',
    },
    socialMedia: {
      placeholders: {
        facebook: 'https://facebook.com/username',
        instagram: 'https://instagram.com/username',
        pinterest: 'https://pinterest.com/username',
        youtube: 'https://youtube.com/channel/username',
        tiktok: "https://tiktok.com/{'@'}username",
      },
    },
    contacts: {
      title: 'Mis Contactos',
      allContacts: 'Todos los Contactos',
      contactCount: '{count} contactos',
      filters: 'Filtros',
      filterTitle: 'Filtrar Contactos',
      search: 'Buscar',
      searchPanelTitle: 'Búsqueda',
      clearSearch: 'Limpiar',
      searchOps: {
        all: 'Todos',
        startsWith: 'Comienza con',
        endsWith: 'Termina con',
        contains: 'Contiene',
        notContains: 'No contiene',
        equals: 'Igual a',
        notEqual: 'Distinto de'
      },
      classId: 'ID de Clase',
      group: 'Grupo de Contacto',
      applyFilters: 'Aplicar Filtros',
      clearFilters: 'Borrar Filtros',
      filterSub: 'Aplicar filtros a los datos de la tabla',
      allClasses: 'Todas las Clases',
      allGroups: 'Todos los Grupos',
      manageContacts: 'Gestiona todos tus contactos.',
      searchPlaceholder: 'Buscar contactos...',
      addFilter: 'Agregar otro filtro...',
      searchHelp: 'Consejo: Usa el nombre, correo electrónico o teléfono para filtrar por campos específicos',
      newContact: 'Nuevo Contacto',
      noContactsFound: 'No se encontraron contactos',
      addSuccess: '¡El contacto se agregó correctamente!',
      updateSuccess: '¡El contacto se actualizó correctamente!',
      addedSuccessfully: 'ha sido agregado correctamente a tus contactos.',
      viewContact: 'Haz clic aquí para ver el contacto',
      deleteConfirm: '¿Estás seguro de que deseas eliminar {email}?',
      sendEmail: 'Enviar Correo Electrónico',
      emailTo: 'Para: {email}',
      emailSubject: 'Asunto',
      emailMessage: 'Mensaje',
      cancel: 'Cancelar',
      send: 'Enviar',
      delete: 'Eliminar',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      actions: 'Acciones',
      edit: 'Editar'
    },
    addContact: {
      title: 'Agregar Contacto',
      editTitle: 'Editar Contacto',
      Communication: 'Comunicación',
      firstName: 'Nombre',
      lastName: 'Apellido',
      preferredName: 'Nombre Preferido',
      email: 'Correo Electrónico',
      noEmail: 'No Hay Dirección de Correo Electrónico Disponible',
      phone: {
        primary: 'Teléfono Principal',
        type: 'Tipo de Teléfono',
        numberPlaceholder: 'Ingresa número de teléfono',
        alternative: 'Teléfono Alternativo',
        cell: 'Celular',
        work: 'Trabajo',
        home: 'Casa',
        other: 'Otro',
      },
      address: {
        sameAsDelivery: 'Igual que dirección de entrega',
        billing: 'Dirección de Facturación'
      },
      requiredFieldsError: 'Por favor completa todos los campos obligatorios (Nombre, Apellido, Correo Electrónico)',
      addressRequiredFieldsError: 'Por favor completa todos los campos de dirección requeridos (Línea de Dirección 1, Ciudad, Código Postal, País, Número de Casa)',
      phoneRequiredError: 'Por favor completa todos los campos del teléfono principal (País, Número, Tipo)',
      save: 'Guardar',
      cancel: 'Cancelar'
    },
    banking: {
      // Page headers
      BankingDetails: 'Detalles Bancarios',
      ManagePaymentAccounts: 'Gestiona tus cuentas de pago para pedidos y comisiones',
      LoadingBankingDetails: 'Cargando información bancaria...',
      PageLoadError: 'No se pudo cargar la información bancaria. Por favor, inténtalo de nuevo.',

      // Current account section
      CurrentPaymentAccount: 'Cuenta de Pago Actual',
      UpdatePaymentAccount: 'Actualizar Cuenta de Pago',
      AddPaymentAccount: 'Agregar Cuenta de Pago',

      // Form fields
      BICCode: 'Código BIC (Código de Identificación Bancaria)',
      BankName: 'Nombre del Banco',
      CurrentIBAN: 'IBAN Actual',
      NewIBAN: 'Nuevo IBAN',
      DirectDebitAuthorization: 'Autorizo los pagos por débito directo para pedidos y comisiones',
      MandateReference: 'Referencia del Mandato',

      // Placeholders
      BICPlaceholder: 'ej., DEUTDEFF',
      AccountHolder: 'Titular de la Cuenta',
      AccountHolderPlaceholder: 'ej., Juan Pérez',
      BankNamePlaceholder: 'ej., Deutsche Bank',
      BankNamePlaceholder2: 'Se completa automáticamente',
      IBANPlaceholder: 'ej., DE89370400440532013000',

      // Validation messages
      BICRequired: 'El código BIC es requerido',
      BICInvalidLength: 'El BIC debe tener entre 8-11 caracteres',
      BICInvalidFormat: 'Formato de BIC inválido',
      InvalidBICCode: 'Código BIC inválido',
      BankNameRequired: 'El nombre del banco es requerido',
      AccountHolderRequired: 'El titular de la cuenta es requerido',
      IBANRequired: 'El IBAN es requerido',
      IBANInvalidLength: 'El IBAN debe tener entre 15-34 caracteres',
      IBANInvalidFormat: 'Formato de IBAN inválido',
      AuthorizationRequired: 'La autorización de débito directo es requerida',

      // Section titles
      ManagePayouts: 'Gestiona tus pagos',
      ConsultantPaymentAccount: 'Tu cuenta de pago de consultor (OPA)',

      // Payout grid
      PayoutAccounts: 'Cuentas de Pago',
      PayoutType: 'Tipo de Pago',
      Country: 'País',
      AccountNumber: 'Número de Cuenta',
      Deposit: 'Depósito',
      NoPayoutAccounts: 'No hay cuentas de pago configuradas',

      payoutType: {
        sepa: 'SEPA',
        bankTransfer: 'Transferencia bancaria',
      },

      // Modal
      AddAccount: 'Agregar Cuenta',
      AddNewAccount: 'Agregar Nueva Cuenta',
      AccountType: 'Tipo de Cuenta',
      DirectDeposit: 'Depósito Directo (Ahorros)',
      Check: 'Cheque',
      DepositPercentage: 'Porcentaje de Depósito',
      DepositPercentagePlaceholder: 'ej., 50',
      DepositPercentageInvalid: 'El porcentaje de depósito debe estar entre 1 y 100',
      IBAN: 'IBAN',
      Save: 'Guardar',
      Cancel: 'Cancelar',

      // Actions
      SaveNewAccount: 'Guardar Nueva Cuenta',
      RemoveAccount: 'Eliminar Cuenta de Pago',
      UpdatePayoutDistribution: 'Actualizar Distribución de Pagos',
      Saving: 'Guardando',
      Removing: 'Eliminando',
      TryAgain: 'Intentar de Nuevo',

      // Validation
      PercentageTotalMustBe100: 'El porcentaje total debe ser igual a 100%. Total actual: {total}%',
      InvalidPayoutPercentage: 'Por favor ajuste el porcentaje de pago. El porcentaje total entre todos los pagos activos y futuros debe ser 100% por período.',

      // Success/Error messages
      SaveSuccess: 'Información bancaria guardada exitosamente',
      SaveError: 'Error al guardar la información bancaria',
      UnknownError: 'Ocurrió un error desconocido',
      RemoveNotImplemented: 'La funcionalidad de eliminación aún no está implementada',
      UpdateDistributionNotImplemented: 'La funcionalidad de actualización de distribución aún no está implementada',

      // Delete confirmation
      DeleteAccount: 'Eliminar Cuenta',
      DeleteAccountConfirmation: '¿Estás seguro de que deseas eliminar esta cuenta de pago?',
      DeleteAccountWarning: 'Esta acción no se puede deshacer.',
      Delete: 'Eliminar',
      DeleteSuccess: 'Cuenta de pago eliminada exitosamente',
      DeleteError: 'Error al eliminar la cuenta de pago'
    },
    reportDashboard: {
      defaultConsultantTitle: 'Executive Director',
      errors: {
        noPeriodDatesAvailable: 'No hay períodos disponibles',
        currentPeriodNotFound: 'No se encontró el período actual',
      },
    },
    QualifiedRecruits: 'Reclutas calificados',
    ActiveConsultants: 'Consultores activos',
    MyDocuments: 'Mis Documentos',
    CommissionStatements: 'Estados de Comisiones',
    TaxDocuments: 'Documentos Fiscales',
    SearchByDocumentTitle: 'Buscar por título del documento',
    NoCommissionDocumentsFound: 'No se encontraron documentos de Estados de Comisiones que coincidan con sus criterios de búsqueda.',
    NoTaxDocumentsFound: 'No se encontraron documentos fiscales que coincidan con sus criterios de búsqueda.',
    Last3Months: 'Últimos 3 Meses',
    Last6Months: 'Últimos 6 Meses',
    Last12Months: 'Últimos 12 Meses',
    Last24Months: 'Últimos 24 Meses',
    AllTime: 'Todo el Tiempo',
    vatLiability: {
      VATLiability: 'Responsabilidad del IVA',
      VATLiabilityDescription: 'Agregue su ID de IVA o Tax ID según la orientación de su asesor fiscal',
      VATInformation: 'Información del IVA',
      VATIDType: 'Tipo de ID',
      VATID: 'ID de IVA',
      TaxID: 'ID Fiscal',
      VATIDPlaceholder: 'Ingrese su ID de IVA o Tax ID',
      LoadingVatInformation: 'Cargando información del IVA...',
      SaveError: 'Error al Guardar Información del IVA',
      SaveSuccess: 'Información del IVA guardada exitosamente',
      TryAgain: 'Intentar de Nuevo',
      Save: 'Guardar',
      Saving: 'Guardando...',
      RequiredField: 'Este campo es requerido',
      InvalidVATFormat: 'Formato de IVA inválido. Use DE + 9 dígitos o ATU + 8 dígitos',
      InvalidVATFormatDE: 'Formato de IVA alemán inválido. Use DE + 9 dígitos (ej., DE123456789)',
      InvalidVATFormatAT: 'Formato de IVA austriaco inválido. Use ATU + 8 dígitos (ej., ATU12345678)',
      InvalidVATFormatFR: 'Formato de IVA francés inválido. Use FR + 2 letras/dígitos + 9 dígitos (ej., FRXX123456789)',
      InvalidVATFormatUS: 'Formato inválido. Use 5-15 caracteres alfanuméricos',
      InvalidTaxIDFormat: 'El Tax ID debe tener al menos 5 caracteres',
      InvalidTaxIDFormatUS: 'Formato de Tax ID estadounidense inválido. Use SSN (123-45-6789) o EIN (12-3456789) o 9 dígitos',
      InvalidTaxIDFormatDE: 'Formato de Tax ID alemán inválido. Use 11 dígitos',
      InvalidTaxIDFormatFR: 'Formato de Tax ID francés inválido. Use 9 dígitos (SIREN)',
      InvalidTaxIDFormatAT: 'Formato de Tax ID austriaco inválido. Use 9 dígitos',
      ValidFormat: 'Formato válido detectado',
      UnknownError: 'Ocurrió un error desconocido',
      VATCannotBeModified: 'La información del IVA no se puede modificar una vez establecida',
      TaxIdNoInputRequired: 'No se requiere entrada para TAXID'
    },
    myStory: {
      MyStoryHeader: 'Mi Historia',
      MyStorySubHeader: 'Comparte tu historia personal y sitio web con los clientes',
      LoadingStory: 'Cargando información de la historia...',
      PageLoadError: 'Error al cargar la página de historia. Por favor, inténtalo de nuevo.',
      SaveError: 'Error al guardar la historia',
      SaveErrorGeneric: 'Ocurrió un error inesperado al guardar tu historia. Por favor, inténtalo de nuevo.',
      SaveSuccess: '¡Historia guardada exitosamente!',
      NetworkError: 'Error de red. Por favor, verifica tu conexión e inténtalo de nuevo.',
      ValidationError: 'Por favor, corrige los errores de validación e inténtalo de nuevo.',
      TryAgain: 'Intentar de Nuevo',
      SaveStory: 'Guardar Historia',
      Saving: 'Guardando...',
      PersonalStorySection: 'Historia Personal',
      PersonalStory: 'Cuenta Tu Historia',
      StoryPlaceholder: 'Comparte tu historia personal, antecedentes y lo que te hace único como consultor...',
      DesignMode: 'Diseño',
      HtmlMode: 'HTML',
      PreviewMode: 'Vista Previa',
      HtmlPlaceholder: 'Ingresa código HTML aquí...',
      WebsiteSection: 'Información del Sitio Web',
      ConsultantWebsite: 'Sitio Web del Consultor',
      LinkToConsultantWeb: 'Enlace a web del consultor:',
      WebsitePlaceholder: 'https://tu-sitio-web.com',
      InvalidURL: 'Por favor ingresa una URL válida (debe comenzar con http:// o https://)'
    },
    companyName: {
      CompanyName: 'Nombre de la Empresa',
      UpdateCompanyInfo: 'Actualiza el nombre de tu empresa y URL de consultor',
      LoadingCompanyName: 'Cargando información de la empresa...',
      PageLoadError: 'Error al cargar la información de la empresa',
      SaveError: 'Error al guardar la información de la empresa',
      SaveErrorGeneric: 'Ocurrió un error inesperado al guardar la información de tu empresa. Por favor, inténtalo de nuevo.',
      SaveSuccess: '¡Información de la empresa guardada exitosamente!',
      NetworkError: 'Error de red. Por favor, verifica tu conexión e inténtalo de nuevo.',
      ValidationError: 'Por favor, corrige los errores de validación e inténtalo de nuevo.',
      TryAgain: 'Intentar de Nuevo',
      SaveCompanyName: 'Guardar Nombre de Empresa',
      Saving: 'Guardando...',
      BusinessNameSection: 'Información del Negocio',
      BusinessName: 'Nombre del Negocio',
      BusinessNamePlaceholder: 'Ingresa el nombre de tu negocio',
      BusinessNameHelp: 'Este nombre se usará en tu URL de consultor y perfil público.',
      BusinessNameRequired: 'El nombre del negocio es requerido',
      BusinessNameTooShort: 'El nombre del negocio debe tener al menos 2 caracteres',
      BusinessNameTooLong: 'El nombre del negocio no puede exceder 100 caracteres',
      BusinessNameInvalidCharacters: 'El nombre del negocio solo puede contener letras, números y símbolos estándar',
      BusinessNameAlreadyExists: 'Este nombre de negocio ya está en uso. Por favor, elige un nombre diferente.',
      ConsultantUrlSection: 'URL del Consultor',
      ConsultantUrl: 'Tu URL de Consultor',
      UrlPlaceholder: 'nombre-de-tu-negocio',
      UrlHelp: 'Esta es la dirección web que los clientes usarán para encontrar tu página de consultor.',
      SearchVisibilitySection: 'Visibilidad en Búsquedas',
      OptOutFromSearch: 'Ya no aparecer en los resultados de búsqueda de consultores',
      OptOutHelp: 'Cuando esté marcado, tu perfil no aparecerá en los resultados de búsqueda pública de consultores.',
      UpdateOptOut: 'Actualizar',
      Updating: 'Actualizando...',
      OptOutUpdateSuccess: '¡Configuración de visibilidad actualizada exitosamente!',
      OptOutUpdateError: 'Error al actualizar la visibilidad',
      OptOutUpdateErrorMessage: 'Ocurrió un error al actualizar tu configuración de visibilidad. Por favor, inténtalo de nuevo.',
      UnauthorizedError: 'No estás autorizado para realizar esta acción. Por favor, inicia sesión de nuevo.',
      TimeoutError: 'La solicitud expiró. Por favor, inténtalo de nuevo.'
    },
    RecruitmentSearch: 'Búsqueda de Reclutamiento',
    RecruitmentSearchDescription: 'Controla tu visibilidad en las búsquedas de reclutamiento de consultores',
    VisibilitySettings: 'Configuración de Visibilidad',
    ShowName: 'Mostrar Nombre',
    ShowLocation: 'Mostrar Ubicación',
    ShowPhoto: 'Mostrar Foto',
    ShowEmail: 'Mostrar Correo Electrónico',
    ShowLandline: 'Mostrar Teléfono Fijo',
    ShowMobile: 'Mostrar Teléfono Móvil',
    LoadingVisibilitySettings: 'Cargando configuración de visibilidad...',
    LoadError: 'Error al cargar configuración',
    TryAgain: 'Intentar de Nuevo',
    SaveError: 'Error al guardar configuración',
    Save: 'Guardar',
    Cancel: 'Cancelar',
    ChangesSaved: 'Cambios guardados exitosamente',
    ChangesDiscarded: 'Cambios descartados'
  },
  thankYou: {
    PageHeader: '¡Gracias por su pedido!',
    SubHeader: 'Su pedido se ha realizado con éxito. Se ha enviado un correo electrónico de confirmación a la dirección de correo electrónico que proporcionó.',
    DetailsAboutOrder: 'Detalles de su pedido',
    orderNumber: 'Número de pedido:',
    PaymentAmount: 'Monto de pago',
    YourItems: 'Sus artículos',
    shippingCost: 'Costo de envío',
    total: 'Total',
    totalTaxAmountInclude: 'Impuestos incluidos'
  },
  orderList: {
    AllOrderTypes: 'Todos los tipos de pedidos',
    AllViews: 'Todos los pedidos',
    ApplyFilterButton: 'Aplicar filtro',
    BetweenAnd: 'Y',
    ClearFilterButton: 'Borrar filtro',
    searchPlaceholder: 'Buscar pedidos...',
    orderCount: '{count} Pedidos',
    CommissionableValue: 'CV',
    ColumnListHeader: 'Columnas',
    ColumnListSubHeader: 'Active y reorganice las columnas que desea ver en su lista de pedidos',
    ColumnOperandBeginsWith: 'Comienza con',
    ColumnOperandBetween: 'Entre',
    ColumnOperandContains: 'Contiene',
    ColumnOperandEquals: 'Es igual a',
    ColumnOperandGreaterThan: 'Mayor que',
    ColumnOperandGreaterThanOrEqual: 'Mayor o igual que',
    ColumnOperandLessThan: 'Menor que',
    ColumnOperandLessThanOrEqual: 'Menor o igual que',
    ColumnOperandNotEquals: 'No es igual a',
    ColumnOperandSelectColumn: 'Seleccionar columna',
    Email: 'Correo electrónico',
    ExportButton: 'Exportar',
    ExportFileName: 'MisPedidos',
    FilterByColumn: 'Filtrar por valor de columna',
    FilterByOrderType: 'Filtrar por tipo de pedido',
    FilterByView: 'Ver'
  },

  dashboard: {
    invoice: {
      orderNumber: 'Número de Orden',
      eventId: 'ID del Evento',
      customerName: 'Nombre del Cliente',
      invoiceNumber: 'Número de Factura',
      amount: 'Monto',
      status: 'Estado de Factura',
      issueDate: 'Fecha de Emisión',
      reads: 'Lecturas',
      hints: 'Sugerencias',
      title: 'Órdenes Abiertas',
      description: 'Realice un seguimiento de las facturas abiertas, cancele o reenvíe facturas cuando sea necesario.',
      allInvoices: 'Todas las Facturas',
      read: 'Leído',
      sent: 'Enviado',
      Issued: 'Emitido',
      NotPaid: 'No Pagado',
      Paid: 'Pagado',
      GridFilterHeader: 'Filtrar Facturas',
      GridFilterSubHeader: 'Utilice las opciones a continuación para filtrar la lista de facturas',
      FilterByStatus: 'Filtrar por Estado',
      FilterByPeriod: 'Filtrar por Período',
      AllStatuses: 'Todos los Estados',
      AllPeriods: 'Todos los Períodos',
      Last30Days: 'Últimos 30 Días',
      Last60Days: 'Últimos 60 Días',
      Last90Days: 'Últimos 90 Días',
      CancelInvoice: 'Cancelar Factura',
      ResendInvoice: 'Reenviar Factura',
      ActionsUnavailableCanceled: 'Esta factura fue cancelada',
      ActionsUnavailablePaid: 'Esta factura fue pagada',
      Resend: 'Reenviar',
      orders: 'órdenes',
      noInvoicesFound: 'No se encontraron facturas para los criterios seleccionados.',
      Cancelled: 'Cancelado',
      Read: 'Leído'
    },
    address: {
      // Page headers
      AddressManagement: 'Gestión de Direcciones',
      ManageAddresses: 'Gestiona tus direcciones de facturación, envío y correspondencia',
      LoadingAddresses: 'Cargando información de direcciones...',
      PageLoadError: 'No se pudo cargar la información de direcciones. Inténtalo de nuevo.',

      // Address types
      BillingAddress: 'Dirección de Facturación',
      DeliveryAddress: 'Dirección de Envío',
      MailingAddress: 'Dirección de Correspondencia',

      // Actions
      AddNew: 'Agregar Nueva',
      Change: 'Cambiar',
      UseExisting: 'Usar Existente',
      Save: 'Guardar',
      Saving: 'Guardando...',
      Cancel: 'Cancelar',
      TryAgain: 'Intentar de Nuevo',

      // Form labels
      ContactInfo: 'Información de Contacto',
      AddressDetails: 'Detalles de la Dirección',
      FirstName: 'Nombre',
      LastName: 'Apellido',
      AddressLine1: 'Línea de Dirección 1',
      AddressLine2: 'Línea de Dirección 2 (Opcional)',
      City: 'Ciudad',
      StateCode: 'Estado/Provincia',
      PostalCode: 'Código Postal',
      CountryCode: 'País',

      // Form titles
      AddNewAddress: 'Agregar Nueva Dirección',
      EditAddress: 'Editar Dirección',
      SelectExistingAddress: 'Seleccionar Dirección Existente',

      // Status messages
      NoAddressSet: 'No hay dirección establecida',
      NoSavedAddresses: 'No hay direcciones guardadas disponibles',

      // Validation messages
      FirstNameRequired: 'El nombre es obligatorio',
      LastNameRequired: 'El apellido es obligatorio',
      AddressLine1Required: 'La línea de dirección 1 es obligatoria',
      CityRequired: 'La ciudad es obligatoria',
      StateCodeRequired: 'El estado/provincia es obligatorio',
      PostalCodeRequired: 'El código postal es obligatorio',
      CountryCodeRequired: 'El país es obligatorio',
      ValidationError: 'Por favor corrige los errores de validación e inténtalo de nuevo',

      // Success/Error messages
      SaveSuccess: '¡Información de dirección guardada exitosamente!',
      SaveError: 'Error al guardar la información de dirección',
      SaveErrorGeneric: 'Ocurrió un error al guardar. Por favor inténtalo de nuevo.',
      NetworkError: 'Error de red. Por favor verifica tu conexión e inténtalo de nuevo.'
    },
    contracts: {
      title: 'Contratos',
      description: 'Ver una lista de contratos que has firmado',
      name: 'Nombre',
      version: 'Versión',
      deliveredOn: 'Entregado En',
      signByDate: 'Fecha Límite de Firma',
      loading: 'Cargando contratos...',
      noContracts: 'No Se Encontraron Contratos',
      noContractsDescription: 'Aún no has firmado ningún contrato.'
    },
    webshopSettings: {
      // Page headers
      WebshopSettings: 'Configuración de Tienda Web',
      ManageWebshopSettings: 'Permite a los consultores gestionar la configuración de la tienda web, métodos de pago y renovaciones',
      LoadingWebshopSettings: 'Cargando configuración de tienda web...',
      PageLoadError: 'No se pudo cargar la configuración de la tienda web. Por favor inténtalo de nuevo.',

      // Plan Selection
      chooseYourPlan: 'Elige Tu Plan',
      manageYourPlan: 'Gestiona Tu Plan',
      activeSubscription: 'Suscripción Activa',
      start90DaysTrial: 'Comienza tu prueba gratuita de 90 días hoy',
      startFreeTrial: 'Iniciar Prueba Gratuita',
      trialPeriod: 'Período de Prueba',
      noPlanSelected: 'Ningún Plan Seleccionado',
      noPlanSelectedMessage: 'Haz clic en un plan a continuación para seleccionarlo para cuando termine tu prueba.',
      noPlanSelectedAssuranceMessage: 'No se te cobrará ni se te inscribirá automáticamente a menos que selecciones un plan.',
      trialActiveMessage: 'Actualmente estás activo en el programa de prueba.',
      trialPlanSelectionNearEndMessage: 'Podrás elegir tu plan a partir de 10 días antes de que termine tu período de prueba ({countdown}). No se te cobrará ni se te inscribirá automáticamente a menos que selecciones un plan.',
      countdownInOneWeek: 'en 1 semana',
      countdownInWeeks: 'en {count} semanas',
      countdownInOneDay: 'en 1 día',
      countdownInDays: 'en {count} días',
      currentSelection: 'Selección Actual',
      plan: 'Plan',
      trialSelectionMessage: 'Puedes cambiar tu plan o cancelar en cualquier momento antes de que termine tu prueba. Tu tarjeta no será cargada si no tienes ningún plan seleccionado.',
      trialEndsOn: 'Tu período de prueba termina el',
      continueToPurchase: 'Continuar con la Compra',
      currentPaymentMethod: 'Método de Pago Actual',
      manageBilling: 'Gestionar Facturación',
      selectPaymentMethod: 'Seleccionar Método de Pago',
      addNewCard: 'Agregar Nueva Tarjeta',
      processingCard: 'Procesando tarjeta...',
      cancel: 'Cancelar',
      select: 'Seleccionar',
      current: 'Actual',
      pending: 'Pendiente',
      monthly: 'Mensual',
      quarterly: 'Trimestral',
      biAnnual: 'Semestral',
      annual: 'Anual',
      savePercent: 'Ahorra {savings}%',
      visa: 'VISA',
      expires: 'Vence',
      processing: 'Procesando...',
      selectAPlan: 'Selecciona un plan',
      confirmPlanSelection: 'Confirmar Selección de Plan',
      confirmPlanMessage: '¿Estás seguro de que quieres seleccionar este plan? Este será tu plan de renovación cuando termine tu prueba.',
      confirm: 'Confirmar',
      pendingChange: 'Cambio Pendiente',
      pendingChangeMessage: 'Puedes cambiar tu plan en cualquier momento. Los cambios tendrán efecto el {renewalDate}.',
      currentPlan: 'Plan Actual',
      month: 'mes',
      sixMonths: '6 meses',
      year: 'año',
      frequency: {
        perMonth: 'por mes',
        everyThreeMonths: 'cada 3 meses',
        everySixMonths: 'cada 6 meses',
        perYear: 'por año',
      },
      planChangeMessage: 'Puedes cambiar tu plan en cualquier momento. Los cambios tendrán efecto en tu próximo ciclo de facturación.',
      upgradeMessage: 'Puedes actualizar a un plan diferente en cualquier momento. Los cambios tendrán efecto en tu próximo ciclo de facturación.',
      subscriptionActive: 'Tu suscripción está activa',
      subscriptionEndsOn: 'Tu suscripción finalizará el: {renewalDate}',
      nextBilling: 'Próxima facturación',
      cancelPendingChange: 'Cancelar Cambio Pendiente',
      cancelPendingChangeTitle: 'Cancelar Cambio Pendiente',
      cancelPendingChangeMessage: '¿Estás seguro de que quieres cancelar tu cambio de plan pendiente? Tu plan actual permanecerá activo.',
      confirmCancel: 'Confirmar Cancelación',
      cancelSubscription: 'Cancelar Suscripción',
      cancelSubscriptionTitle: 'Cancelar Suscripción',
      cancelSubscriptionMessage: 'Tu suscripción no será renovada después de la fecha de renovación. ¿Estás seguro de que quieres cancelar?',
      confirmCancelSubscription: 'Confirmar Cancelación',
      subscriptionCancelledMessage: 'Has cancelado tu suscripción. Tu suscripción no será renovada después de la fecha de renovación. Podrás reinscribirte después de que tu suscripción actual finalice.',
      deleteCardTitle: 'Eliminar Tarjeta',
      deleteCardMessage: '¿Estás seguro de que quieres eliminar esta tarjeta? Esta acción no se puede deshacer.',
      confirmDeleteCard: 'Eliminar Tarjeta',

      // Expired/No Active Subscription State
      noActiveSubscription: 'Sin Suscripción Activa',
      noCurrentSubscription: 'Sin Suscripción Actual',
      noCurrentSubscriptionMessage: 'Selecciona un plan a continuación para comenzar. Puedes cambiar o cancelar en cualquier momento.',
      invalidPaymentMethod: 'Método de pago inválido',
      invalidPaymentMethodMessage: 'Agregue o cambie su método de pago.',
      paymentDue: 'Pago pendiente',
      renewalProcessingTitle: 'Renovación en Proceso',
      renewalProcessingMessage: 'Tu cambio de renovación se está procesando actualmente. Espera mientras se completa esta actualización.',
      renewalProcessingPendingLabel: 'Tu renovación se está procesando. Las acciones de planes y facturación no están disponibles temporalmente.',
      getStartedToday: 'Comienza hoy',
      choosePlanToBegin: 'Elige un plan para comenzar tu suscripción',
      paymentSetupRequired: 'Configuración de Pago Requerida',
      paymentSetupMessage: 'Se te pedirá agregar un método de pago después de seleccionar tu plan. No se realizarán cargos hasta que confirmes.',
      reenroll: 'Reinscribirse',

      // Actions
      ChangePlan: 'Cambiar Plan',
      Enroll: 'Inscribirse',
      RenewEnrollment: 'Renovar Inscripción',
      Reenroll: 'Reinscribirse',
      TerminateOnlineShop: 'Terminar Tienda En Línea',
      Unenroll: 'Cancelar Inscripción',
      UpdatePendingChanges: 'Actualizar Cambios Pendientes',
      RevertPendingChanges: 'Revertir Cambios Pendientes',
      TryAgain: 'Intentar de Nuevo',

      // Current Plan Section
      CurrentPlan: 'Información del Plan Actual',
      PlanName: 'Nombre del Plan',
      RenewalFrequency: 'Frecuencia de Renovación',
      ProcessStatus: 'Estado del Proceso',
      NextRenewalDate: 'Próxima Fecha de Renovación',

      // Current Configuration Section
      CurrentConfiguration: 'Configuración Actual',
      CurrentProgramName: 'Nombre del Programa Actual',
      CurrentOptionalPrograms: 'Programas Opcionales Actuales',
      RenewalDate: 'Fecha de Renovación',
      ExpiresOn: 'Expira El',

      // Current Program Section (legacy)
      CurrentProgram: 'Información del Programa Actual',
      RequiredProgram: 'Programa Requerido',
      OptionalPrograms: 'Programas Opcionales',
      NoOptionalPrograms: 'Sin programas opcionales',

      // Pending Changes Section
      PendingChanges: 'Cambios Pendientes',
      Current: 'Configuración Actual',
      Pending: 'Configuración Pendiente',
      PendingConfiguration: 'Configuración Pendiente',
      Program: 'Programa',
      PeriodName: 'Nombre del Período',
      FuturePeriodName: 'Nombre del Período Futuro',
      FutureProgramName: 'Nombre del Programa Futuro',
      FutureOptionalPrograms: 'Programas Opcionales Futuros',
      EffectiveDate: 'Fecha Efectiva',

      // Next Payment Section
      NextPayment: 'Próximo Pago',
      RenewalOverdue: 'Renovación Vencida',
      AccountOverdueMessage: 'Su renovación de cuenta está vencida. Por favor actualice su información de pago.',
      CardWillBeCharged: 'Su tarjeta será cargada',

      // Payment Information Section (legacy)
      PaymentInformation: 'Información de Pago',
      NextChargeAmount: 'Monto del Próximo Cargo',
      NextChargeDate: 'Fecha del Próximo Cargo',

      // Secondary Plan Section
      SecondaryPlan: 'Información del Plan Secundario',
      SecondaryPlanName: 'Nombre del Plan Secundario',
      SecondaryStatus: 'Estado Secundario',
      SecondaryRenewalDate: 'Fecha de Renovación Secundaria',
      SecondaryRenewalConfigurationPending: 'El estado de configuración de renovación está pendiente',

      // Configuration Status Messages
      RenewalConfigurationPending: 'Configuración de Renovación Pendiente',
      RenewalConfigurationPendingMessage: 'Su configuración de renovación está siendo procesada actualmente. Por favor vuelva a consultar más tarde.',
      NoActivePlan: 'Sin Plan Activo',
      NoActivePlanMessage: 'Actualmente no estás inscrito en ningún plan. Haz clic en "Reinscribirse" para unirte a un programa de renovación.',

      // Status values
      StatusActive: 'Activo',
      StatusPending: 'Pendiente',
      StatusExpired: 'Vencido',
      StatusCancelled: 'Cancelado',
      StatusProcessing: 'Procesando',

      // Success/Error messages
      SaveSuccess: '¡Configuración de tienda web actualizada exitosamente!',
      SaveError: 'Error al actualizar la configuración de la tienda web',
      SaveErrorGeneric: 'Ocurrió un error al actualizar. Por favor inténtalo de nuevo.',
      NetworkError: 'Error de red. Por favor verifica tu conexión e inténtalo de nuevo.',

      // Change Plan Modal
      ChangePlanModalTitle: 'Cambiar Plan',
      ChangePlanModalDescription: 'Selecciona una nueva frecuencia de renovación y programas para tu plan',
      SelectRenewalFrequency: 'Seleccionar Frecuencia de Renovación',
      RenewalFrequencyPlaceholder: 'Elegir frecuencia de renovación...',
      LoadingRenewalFrequencies: 'Cargando frecuencias de renovación...',
      NoRenewalFrequenciesAvailable: 'No hay frecuencias de renovación disponibles',
      RequiredPrograms: 'Programas Requeridos',
      OptionalProgramsSelection: 'Programas Opcionales',
      LoadingPrograms: 'Cargando programas...',
      NoProgramsAvailable: 'No hay programas disponibles',
      Kits: 'Kits',
      LoadingKits: 'Cargando kits...',
      NoKitsAvailable: 'No hay kits disponibles para los programas seleccionados',
      SelectProgram: 'Por favor selecciona un programa para ver los kits disponibles',
      Cancel: 'Cancelar',
      SaveChanges: 'Guardar Cambios',
      ChangePlanSuccess: '¡Plan cambiado exitosamente!',
      ChangePlanError: 'Error al cambiar el plan',

      // Revert Confirmation Modal
      ConfirmRevert: 'Confirmar Revertir Cambios',
      ConfirmRevertMessage: '¿Estás seguro de que deseas revertir los cambios pendientes? Esta acción no se puede deshacer.',
      ConfirmRevertButton: 'Sí, Revertir Cambios',

      // Select Payment Method Modal
      SelectPaymentMethod: 'Seleccionar Método de Pago',
      SelectPaymentDescription: 'Elige el método de pago que deseas usar para los pagos de renovación',
      LoadingPaymentMethods: 'Cargando métodos de pago...',
      NoPaymentMethodsAvailable: 'No hay métodos de pago disponibles. Por favor agrega un método de pago primero.',
      CurrentRenewalCard: 'Renovación Actual',
      CardNumber: 'Número de Tarjeta',
      ExpirationDate: 'Fecha de Expiración',
      HolderName: 'Nombre del Titular',
      ConfirmSelection: 'Confirmar Selección',

      // Renewal Countdown Notification
      RenewalReminder: 'Recordatorio de Renovación',
      RenewalReminderMessage: '¡Tu renovación está próxima en {days} días!'
    },
    uploadPhoto: {
      UploadPhotoHeader: 'Subir Foto Profesional',
      UploadPhotoSubHeader: 'Sube una foto profesional para personalizar tu perfil',
      LoadingPhoto: 'Cargando información de la foto...',
      PageLoadError: 'Error al cargar la página de subida de fotos. Por favor inténtalo de nuevo.',
      SaveError: 'Error al subir la foto',
      SaveSuccess: '¡Foto subida exitosamente!',
      TryAgain: 'Intentar de Nuevo',
      CurrentPhoto: 'Foto de Perfil Actual',
      ProfilePhotoAlt: 'Foto de perfil',
      UploadFile: 'Haz clic para subir o arrastra y suelta',
      MaxFileSize: 'Tamaño máximo de archivo: 4 MB',
      SupportedFormats: 'Formatos soportados: JPEG, PNG',
      SelectedFile: 'Archivo Seleccionado',
      RemoveFile: 'Eliminar Archivo',
      PreviewAlt: 'Vista previa',
      FileTooLarge: 'El tamaño del archivo excede el límite de 4 MB. Por favor elige un archivo más pequeño.',
      InvalidFileFormat: 'Formato de archivo inválido. Por favor selecciona una imagen JPEG o PNG.',
      UnknownError: 'Ocurrió un error desconocido. Por favor inténtalo de nuevo.',
      Save: 'Guardar Foto',
      Uploading: 'Subiendo...',
      RejectedPhotos: 'Fotos Rechazadas Anteriormente',
      RejectedPhotoAlt: 'Foto rechazada',
      RejectionReason: 'Razón del Rechazo'
    },
    walletInformation: {
      WalletInformation: 'Información de Billetera',
      WalletDescription: 'Gestiona la información de tu tarjeta de crédito para pagos seguros',
      CardName: 'Nombre de la Tarjeta',
      CardNumber: 'Número de Tarjeta',
      PayPalAccount: 'Cuenta de PayPal',
      PayPalEmail: 'Correo de PayPal',
      ExpirationDate: 'Fecha de Vencimiento',
      NameOnCard: 'Nombre en la Tarjeta',
      CVV: 'CVV',
      AddCard: 'Agregar Tarjeta',
      EditCard: 'Editar Tarjeta',
      DeleteCard: 'Eliminar Tarjeta',
      ExtendCard: 'Extender Tarjeta',
      SetAsDefault: 'Establecer como Predeterminada',
      DefaultCard: 'Tarjeta Predeterminada',
      ExpiredCard: 'Tarjeta Vencida',
      ExpiresOn: 'Vence el',
      CardType: 'Tipo de Tarjeta',
      LastFour: 'Últimos Cuatro',
      NoCardsFound: 'No Se Encontraron Tarjetas',
      NoCardsDescription: 'Aún no has agregado ningún método de pago.',
      LoadingCards: 'Cargando métodos de pago...',
      AddingCard: 'Agregando tarjeta...',
      UpdatingCard: 'Actualizando tarjeta...',
      DeletingCard: 'Eliminando tarjeta...',
      ExtendingCard: 'Extendiendo tarjeta...',
      SettingDefault: 'Estableciendo como predeterminada...',
      CardAdded: 'Tarjeta agregada exitosamente',
      CardUpdated: 'Tarjeta actualizada exitosamente',
      CardDeleted: 'Tarjeta eliminada exitosamente',
      CardExtended: 'Fecha de vencimiento de tarjeta extendida exitosamente',
      PayPalAdded: 'Cuenta de PayPal agregada exitosamente',
      DefaultCardSet: 'Método de pago predeterminado actualizado',
      AddCardError: 'Error al agregar tarjeta',
      UpdateCardError: 'Error al actualizar información de tarjeta',
      ExtendCardError: 'Error al extender fecha de vencimiento de tarjeta',
      DeleteCardError: 'Error al eliminar tarjeta',
      PayPalError: 'Error al agregar cuenta de PayPal',
      SetDefaultError: 'Error al establecer tarjeta predeterminada',
      LoadCardsError: 'Error al cargar métodos de pago',
      CardNameRequired: 'El nombre de la tarjeta es requerido',
      CardNumberRequired: 'El número de tarjeta es requerido',
      ExpirationDateRequired: 'La fecha de vencimiento es requerida',
      NameOnCardRequired: 'El nombre en la tarjeta es requerido',
      CVVRequired: 'El CVV es requerido',
      InvalidCardNumber: 'Número de tarjeta inválido',
      InvalidExpirationDate: 'Fecha de vencimiento inválida',
      CardExpired: 'La tarjeta ha vencido',
      CardNumberFormat: 'El número de tarjeta debe tener 13-19 dígitos',
      ExpirationFormat: 'Usar formato MM/AAAA',
      CVVFormat: 'El CVV debe tener 3-4 dígitos',
      ConfirmDeleteCard: '¿Estás seguro de que quieres eliminar esta tarjeta?',
      ConfirmDeleteCardMessage: 'Esta acción no se puede deshacer.',
      Cancel: 'Cancelar',
      Confirm: 'Confirmar',
      Save: 'Guardar',
      Close: 'Cerrar',
      Edit: 'Editar',
      Delete: 'Eliminar',
      Extend: 'Extender',
      UsePaymentMethod: 'Usar Método de Pago',
      NewExpirationDate: 'Nueva Fecha de Vencimiento',
      ExtendCardTitle: 'Extender Validez de Tarjeta',
      ExtendCardDescription: 'Actualizar la fecha de vencimiento para esta tarjeta',
      UpdateCardExpiration: 'Actualizar Vencimiento de Tarjeta',
      UpdateExpiration: 'Actualizar Vencimiento',
      NoDefaultWarning: 'No hay método de pago predeterminado seleccionado. Por favor establece una tarjeta predeterminada para transacciones.',
      TryAgain: 'Intentar de Nuevo',
      SetAsPrimary: 'Asignar como método de pago principal',
      SetAsPrimaryDescription: 'Hacer este tu método de pago predeterminado para transacciones',
      AccountName: 'Nombre de Cuenta',
      Usage: 'Uso',
      AccountNameRequired: 'El nombre de cuenta es requerido',
      UsageRequired: 'El uso es requerido',
      Name: 'Nombre',
      HolderName: 'Nombre del Titular',
      Use: 'Uso',
      ProcessingCard: 'Procesando información de la tarjeta...'
    },
    FrenchContribution: 'Documentos Fiscales Franceses',
  },
  richTextEditor: {
    designMode: 'Diseño',
    htmlMode: 'HTML',
    previewMode: 'Vista Previa',
    normalText: 'Texto Normal',
    heading1: 'Encabezado 1',
    heading2: 'Encabezado 2',
    heading3: 'Encabezado 3',
    paragraph: 'Párrafo',
    textColor: 'Color de Texto',
    backgroundColor: 'Color de Fondo',
    createLink: 'Crear Enlace',
    removeLink: 'Quitar Enlace',
    enterUrl: 'Ingresa la URL:',
    htmlPlaceholder: 'Ingresa código HTML aquí...'
  },
  frenchContribution: {
    FrenchContributionHeader: 'Documentos Fiscales Franceses',
    FrenchContributionSubHeader: 'Sube tus documentos fiscales para revisión y aprobación de cumplimiento',
    SiretNumber: 'Número SIRET',
    UploadFile: 'Haz clic para subir o arrastra y suelta tu documento fiscal',
    MaxFileSize: 'Tamaño máximo de archivo: 10MB',
    SupportedFormats: 'Formato compatible: Solo PDF',
    SelectedFile: 'Archivo Seleccionado',
    RemoveFile: 'Quitar Archivo',
    Upload: 'Subir Documento',
    Uploading: 'Subiendo...',
    LoadingDocuments: 'Cargando documentos...',
    PageLoadError: 'Error al cargar la sección de contribución francesa',
    SaveError: 'Error en la Subida',
    SaveSuccess: '¡Documento subido exitosamente! Tu documento fiscal ha sido enviado para revisión.',
    TryAgain: 'Intentar de Nuevo',
    FileTooLarge: 'El tamaño del archivo excede el límite de 10MB. Por favor elige un archivo más pequeño.',
    InvalidFileFormat: 'Solo se admiten archivos PDF. Por favor selecciona un documento PDF.',
    UnknownError: 'Ocurrió un error inesperado. Por favor intenta de nuevo.'
  },
  businessDetails: {
    Title: 'Detalles del Negocio',
    ShowChart: 'Mostrar gráfico',
    ShowGrid: 'Mostrar tabla',
    Metrics: 'Métricas',
    ChartTitle: 'Métricas comerciales a lo largo del tiempo',
    errors: {
      noColumnsFoundInReportDefinition: 'No se encontraron columnas en la definición del informe',
      noBatchHistoryFound: 'No se encontró historial de lotes',
      failedToLoadData: 'No se pudieron cargar los datos',
    },
  },
  ccReport: {
    Filters: 'Filtros',
    ApplyFiltersToTableData: 'Aplicar filtros a los datos de la tabla',
    NoFilterableColumns: 'No hay columnas filtrables disponibles para este informe.',
    StartDate: 'Fecha de inicio',
    EndDate: 'Fecha de fin',
    ClearFilters: 'Limpiar filtros',
    ApplyFilters: 'Aplicar filtros',
    IncludeTeam: 'Incluir equipo',
    RemoveTeam: 'Eliminar equipo',
    ShowingItems: '{0} - {1} de {2} elementos',
    NoRecordsAvailable: 'No hay registros disponibles',
    ExpandAll: 'Expandir todo',
    CollapseAll: 'Contraer todo',
    ExportToExcel: 'Exportar a Excel',
    SearchByName: 'Buscar por nombre',
    DataUpdatedAsOf: 'Datos actualizados: {datetime}',
    DrilldownLoadError: 'No se pudieron cargar los detalles'
  },
  ccConsultantDetail: {
    ConsultantDetails: 'Detalles del Consultor',
    LoadingDetails: 'Cargando detalles del consultor...',
    FullName: 'Nombre Completo',
    Status: 'Estado',
    Address: 'Dirección',
    Phone: 'Teléfono',
    Email: 'Correo Electrónico',
    Sponsor: 'Patrocinador',
    Recruiter: 'Reclutador',
    NoAddressAvailable: 'No hay dirección disponible',
    NotAvailable: 'N/D',
    Retry: 'Reintentar',
    ProfilePhotoAlt: 'Foto de perfil del consultor',
    AddBookmark: 'Agregar marcador',
    RemoveBookmark: 'Eliminar marcador',
    BusinessDetails: 'Detalles del Negocio',
    ViewBusinessDetails: 'Ver Detalles del Negocio',
    SearchConsultant: 'Buscar Consultor',
    SearchPlaceholder: 'Escriba para buscar consultores...',
    Bookmark: 'Marcador',
    BookmarkedConsultants: 'Consultores Marcados',
    NoBookmarkedConsultants: 'Aún no hay consultores marcados'
  },
  eventManagement: {
    AddGuest: 'Agregar Invitado',
    AddGuestButton: 'Agregar Invitados Seleccionados',
    FindGuestError: 'Por favor selecciona al menos un invitado para agregar',
    DuplicateGuestError: 'Este invitado ya ha sido agregado al evento',
    AddGuestCancelButton: 'Cancelar',
    BreadCrumbPage: 'Fiesta',
    CreateOrder: 'Crear Pedido',
    DeleteButton: 'Eliminar',
    EmailAddress: 'Dirección de Correo',
    EventDate: 'Fecha',
    EventID: 'ID del Evento',
    EventInfo: 'Información del Evento',
    EventList: 'Inicio',
    EventEndTime: 'Hora de Fin',
    EventStartTime: 'Hora de Inicio',
    EventStatus: 'Estado del Evento',
    EventTitle: 'Título del Evento',
    EventType: 'Tipo de Evento',
    EventWhen: 'Cuándo',
    EventWhere: 'Dónde',
    FindContact: 'Buscar Contacto',
    FirstName: 'Nombre',
    GuestInfo: 'Información de Invitados',
    GuestName: 'Nombre',
    GuestRole: 'Rol',
    Guests: 'Invitados',
    Hostess: 'Anfitriona',
    HostEmail: 'Correo del Anfitrión',
    HostName: 'Nombre del Anfitrión',
    HostPhoneNumber: 'Teléfono del Anfitrión',
    InviteOpened: 'Invitación Abierta',
    InviteVisited: 'Invitación Visitada',
    LastName: 'Apellido',
    MakeHost: 'Hacer Anfitrión',
    NewContact: 'Nuevo Contacto',
    OrderTotal: 'Total / Pendiente',
    PhoneNumber: 'Número de Teléfono',
    PlaceOrder: 'Realizar Pedido',
    RSVP: 'RSVP',
    SaveButton: 'Guardar',
    SendEmail: 'Enviar Correo',
    ViewReceipt: 'Ver Recibo',
    TransferButton: 'Transferir Evento',
    SendEmailTo: 'Enviar Correo A',
    EmailSubject: 'Asunto del Correo',
    EmailBody: 'Cuerpo del Correo',
    Cancel: 'Cancelar',
    Send: 'Enviar',
    // Host Portal Messages
    HostPortalHeader: 'Portal del anfitrión',
    HostPortalStep1: 'Paso 1: Configurar el portal del anfitrión',
    HostPortalStep2: 'Paso 2: Crear contraseña',
    HostPortalStep3: 'Paso 3: Enviar invitación',
    ChooseTheme: 'Elige el tema del portal del anfitrión',
    ImagePreview: 'Vista previa de imagen sobre el tema:',
    PasswordPlaceholder: 'Ingresa contraseña para el anfitrión (ej., Cooking Show1)',
    OptionalNote: 'Nota opcional:',
    CcMeOnEmails: 'Enviarme copia de todos los correos sobre el portal del anfitrión',
    SendEmailButton: 'Enviar correo',
    SavePortalSettings: 'Guardar configuración del portal',
    ViewHostDashboard: 'Ver Panel del Anfitrión',
    HostPortalColumn: 'Portal del anfitrión',
    ManageHostPortal: 'Administrar',
    ViewHostPortal: 'Ver',
    // Email Editor Messages
    EmailPreview: 'Vista previa del correo',
    To: 'Para',
    From: 'De',
    Regarding: 'Asunto',
    SendInvitation: 'Enviar invitación',
    // Success Messages
    PortalSettingsSaved: 'Configuración del portal guardada',
    InvitationEmailSent: 'Correo de invitación enviado',
    // Default Values
    NoEmailTemplate: 'No hay plantilla de correo disponible',
    // Error Messages
    CopyFailed: 'Error al copiar al portapapeles',
    // Validation Messages
    EventDatePastError: 'La fecha del evento no puede estar en el pasado',
    EventEndTimeBeforeStartError: 'La hora de fin no puede ser antes de la hora de inicio',
    InvalidEmailFormat: 'Por favor ingresa una dirección de correo válida',
    MissingRequiredFields: 'Faltan los siguientes campos obligatorios: {fields}',
    CannotCloseEventWithItemsTitle: 'No se Puede Cerrar el Evento',
    CannotCloseEventWithItemsMessage: 'Este evento no se puede cerrar porque hay carritos sin enviar con artículos. Por favor asegúrate de que todos los carritos estén vacíos o enviados antes de cerrar el evento.',
    CannotDeleteEventWithItemsTitle: 'No se Puede Eliminar el Evento',
    CannotDeleteEventWithItemsMessage: 'Este evento no se puede eliminar porque hay carritos sin enviar con artículos. Por favor asegúrate de que todos los carritos estén vacíos o enviados antes de eliminar el evento.',
    // Cart URL Messages
    CartPageUrl: 'URL de la Página de Compras',
    CartPageUrlUnavailable: 'La URL de la página de compras no está disponible mientras tu tienda pública esté deshabilitada.',
    CopyCartUrl: 'Copiar URL',
    Copied: '¡Copiado!',
  },
  kit: {
    miniHeader: 'Aquí está todo lo que necesitas para comenzar.',
    kitHeader: 'Elige un Kit con Nuestras Herramientas Más Vendidas',
    startForFree: '¿Te gustaría comenzar gratis sin un kit de inicio? Por favor contacta',
    contactLabel: 'Contactar:',
    details: 'Detalles',
    productsInKit: 'Productos en Este Kit:',
    startUpBox: 'Caja de Inicio:',
    totalValue: '(¡{0} valor total!)'
  },
  gamificationDifferenceMessage: {
    OrderTotal_FreeShipping: 'Envío gratis cuando gastes más de {totalAmount}',
    PartyOrderTotal_FreeShipping: 'Envío gratis cuando gastes más de {totalAmount}',
    OrderTotal: 'Gasta solo {difference} más para obtener descuentos adicionales',
  },
  phoneInput: {
    placeholder: 'Ingresa número de teléfono',
    phoneNumber: 'Número de teléfono',
    extension: 'Ext.',
    type: 'Tipo de teléfono',
    home: 'Casa',
    cell: 'Móvil',
    work: 'Trabajo',
    other: 'Otro',
    required: 'El número de teléfono es obligatorio',
    invalid: 'Por favor ingresa un número de teléfono válido',
    country: {
      DE: 'DE',
      AT: 'AT',
      FR: 'FR',
    }
  },
  marketing: {
    optInConfirm: {
      title: 'Confirmación de correo electrónico',
      confirmedMessage: 'Gracias por confirmar tu suscripción por correo electrónico.',
      noEmailProvided: 'No se proporcionó ninguna dirección de correo electrónico.',
    },
  },
  hostPortalPage: {
    loadingEventDetails: 'Cargando detalles del evento...',
    genericErrorTitle: '¡Ups! Algo salió mal',
    tryAgain: 'Intentar de nuevo',
    eventTitleFallback: "Evento de {name}",
    eventSubtitle: 'Evento de Pampered Chef',
    eventImageAlt: 'Imagen del evento {number}',
    descriptionTitle: '¡Consiente tu cocina este verano!',
    hostedBy: 'Organizado por',
    location: 'Ubicación',
    eventDescription: '¡Bienvenido a mi evento de Pampered Chef! Únete para pasar un buen rato con excelentes productos.',
    shopNow: 'Comprar ahora',
    shareThisInvite: 'Comparte esta invitación',
    shareText: 'Texto',
    shareFacebook: 'Facebook',
    shareEmail: 'Correo',
    copy: 'Copiar',
    starts: 'Comienza',
    hostingQuestion: '¿Estás organizando la fiesta?',
    signInToSeeDashboard: 'Inicia sesión para ver tu panel',
    inviteLinkCopiedTitle: 'Copiado',
    inviteLinkCopiedMessage: 'Enlace de invitación copiado al portapapeles',
    unknownHost: 'Anfitrión desconocido',
    errors: {
      noEventIdProvided: 'No se proporcionó ID del evento',
      eventNotFound: 'Evento no encontrado',
      loadingEventDetails: 'Error al cargar los detalles del evento',
      copyInviteLinkFailed: 'No se pudo copiar el enlace de invitación',
      guestNotFound: 'Invitado no encontrado para este evento',
      loadingGuestDetails: 'Error al cargar los datos del invitado',
      updateStatusFailed: 'No se pudo actualizar tu RSVP. Inténtalo de nuevo.',
    },
    guestSection: {
      heading: 'Tu RSVP',
      greeting: 'Hola {name},',
      currentStatusLabel: 'Tu estado actual:',
      changeStatusLabel: 'Actualizar tu RSVP:',
      statusUpdatedTitle: 'RSVP actualizado',
      statusUpdatedMessage: '¡Gracias! Tu RSVP se ha guardado.',
    },
  }
  ,
  kendo: {
    grid: {
      pagerItemsPerPage: 'elementos por página',
      pagerInfo: '{0} - {1} de {2} elementos',
      noRecords: 'No hay registros disponibles',
    },
  },
  countries: {
    germany: 'Alemania',
    austria: 'Austria',
    france: 'Francia',
    switzerland: 'Suiza',
    belgium: 'Bélgica',
    spain: 'España',
    italy: 'Italia',
    netherlands: 'Países Bajos',
    poland: 'Polonia',
    unitedKingdom: 'Reino Unido',
    ireland: 'Irlanda',
    portugal: 'Portugal',
    sweden: 'Suecia',
    denmark: 'Dinamarca',
    norway: 'Noruega',
    finland: 'Finlandia',
    unitedStates: 'Estados Unidos',
    canada: 'Canadá',
    australia: 'Australia',
    newZealand: 'Nueva Zelanda',
    japan: 'Japón',
    china: 'China',
    brazil: 'Brasil',
    mexico: 'México',
    india: 'India',
    unknown: 'Desconocido',
  },
  pagination: {
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    goToPage: 'Ir a la página {page}',
    ellipsis: '...',
  }
}
